<template>
  <div class="row">
    <div class="col-12">
      <h1>Datos Personales</h1>
    </div>

    <div v-if="M_Persona.Persona.PersonaId" class="col-2 text-center">      
      <RostroDePersona  
        :personaId="M_Persona.Persona.PersonaId"       
        :conBotonDeSubidor="true"        
        :conBotonDeDescarga="true"              
      >
      </RostroDePersona>
      <hr>
      <h5>Firma autógrafa</h5>
      
      <FirmaAutografa
      :personaId="M_Persona.Persona.PersonaId"
      :propImagenFirmaAutografaBase64="M_Persona.Persona.ImagenFirmaAutografaBase64"
      >
      </FirmaAutografa>

    </div>
    <div class="col-10">
      <ul class="nav nav-tabs" id="tabAltaUsuario" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            id="personales-tab"
            data-toggle="tab"
            href="#personales"
            role="tab"
            aria-controls="personales"
            aria-selected="true"
            >Personales</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ disabled: disableTabAcademicos }"
            id="academicos-tab"
            data-toggle="tab"
            href="#academicos"
            role="tab"
            aria-controls="academicos"
            aria-selected="false"
            >Académicos</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ disabled: disableTabLaborales }"
            id="laborales-tab"
            data-toggle="tab"
            href="#laborales"
            role="tab"
            aria-controls="laborales"
            aria-selected="false"
            >Laborales</a
          >
        </li>
        <!-- <li class="nav-item">
          <a
            class="nav-link"
            :class="{ disabled: disableTabSuperiores }"
            id="superior-tab"
            data-toggle="tab"
            href="#superior"
            role="tab"
            aria-controls="superior"
            aria-selected="false"
            >Superior</a
          >
        </li> -->
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ disabled: disableTabFamiliares }"
            id="familiares-tab"
            data-toggle="tab"
            href="#familiares"
            role="tab"
            aria-controls="familiares"
            aria-selected="false"
            >Familiares</a
          >
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <!--Contenido del tabulador Personales-->
        <div
          class="tab-pane fade show active"
          id="personales"
          role="tabpanel"
          aria-labelledby="personales-tab"
        >
          <div class="row">
            <div class="col-12">
              <div class="form-group area">
                <!-- Fila de la CURP -->
                <div class="row">
                  <div class="form-group-h col-6">
                    <label for="CURP">CURP</label>
                    <input
                      v-model="M_Persona.Persona.CURP"
                      id="CURP"
                      name="CURP"
                      class="form-control"
                      placeholder="CURP"
                      v-mask="'AAAA######AAAAAAN#'"
                      :readonly="readOnlyCURP"
                    />
                  </div>
                  <div class="form-group col-3">
                    <button
                      v-on:click="ValidaSiExisteUsuario(0)"
                      class="btn btn-primary"
                      :disabled="this.ValidarCURP(0)"
                    >
                      Buscar
                    </button>
                  </div>
                  <div class="form-group col-3">
                    <button
                      v-on:click="VaciarDatosDePersona"
                      class="btn btn-light"
                    >
                      Limpiar
                    </button>
                  </div>
                </div>
                <div
                  v-if="
                    !this.M_Persona.Persona.Activo &&
                      this.M_Persona.Persona.PersonaId
                  "
                  class="row"
                >
                  <!-- Se muestra cuando es una persona con estatus inactivo y que no tiene valor en PersonaId                     -->
                  <div class="col-3">
                    <div class="custom-control custom-checkbox">
                      <input
                        v-model="activarPersonaDesactivada"
                        type="checkbox"
                        class="custom-control-input"
                        id="inputEstatusDelUsuario"
                      />
                      <label
                        class="custom-control-label"
                        for="inputEstatusDelUsuario"
                        >Activar persona</label
                      >
                    </div>
                  </div>
                  <div class="col-2">
                    <button
                      v-bind:disabled="!this.activarPersonaDesactivada"
                      v-on:click="AbrilModalActivarPersona"
                      class="btn btn-primary"
                    >
                      Activar
                    </button>
                  </div>
                </div>
                <hr />
                <!--Nombre, Apellido paterno, Apellido materno-->
                <div v-bind:class="{ 'area-inactiva': noEsPermitidoEditar }">
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="nombrePersona">Nombre</label>
                      <input
                        v-model="M_Persona.Persona.Nombre"
                        id="nombrePersona"
                        name="nombrePersona"
                        class="form-control"
                        placeholder="Nombre"
                      />
                    </div>
                    <div class="form-group col-4">
                      <label for="apellidoPaterno">Apellido Paterno</label>
                      <input
                        v-model="M_Persona.Persona.ApellidoPaterno"
                        id="apellidoPaterno"
                        name="apellidoPaterno"
                        class="form-control"
                        placeholder="Apellido Paterno"
                        type="text"
                      />
                    </div>
                    <div class="form-group col-4">
                      <label for="apellidoMaterno">Apellido Materno</label>
                      <input
                        v-model="M_Persona.Persona.ApellidoMaterno"
                        id="apellidoMaterno"
                        name="apellidoMaterno"
                        class="form-control"
                        placeholder="Apellido Materno"
                        type="text"
                      />
                    </div>
                  </div>
                  <!--Correo electrónico, RFC, NSS-->
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="correoElectronico">Correo Electrónico</label>
                      <input
                        v-model="M_Persona.Persona.CorreoElectronico"
                        id="correoElectronico"
                        name="correoElectronico"
                        class="form-control"
                        placeholder="Correo Electrónico"
                      />
                    </div>
                    <div class="form-group col-4">
                      <label for="RFC">RFC</label>
                      <input
                        v-model="M_Persona.Persona.RFC"
                        id="RFC"
                        name="RFC"
                        class="form-control"
                        placeholder="RFC"
                        v-mask="'AAAA######NNN'"
                      />
                    </div>
                    <div class="form-group col-4">
                      <label for="NSS">NSS</label>
                      <input
                        v-model="M_Persona.Persona.NSS"
                        id="NSS"
                        name="NSS"
                        class="form-control"
                        placeholder="Número de Seguro Social"
                        v-mask="'###########'"
                      />
                    </div>
                  </div>
                  <!--Estado civil, Numero de nomina, Sexo-->
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="tipoEstadosCivilesCombo">Estado Civil</label>
                      <C041TiposEstadosCiviles
                        id="tipoEstadoCivilCombo"
                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                        :tipo="enumeraciones.tiposDeSelect.Seleccione"
                        :idDelInput="'altaUsuario_TipoEstadoCivil_Personales'"
                        :valorDefinido="
                          M_Persona.Persona.TipoEstadoCivil.TipoEstadoCivilId
                        "
                        v-on:valorParaElPadre="cambioDeTipoEstadoCivil"
                        :key="
                          M_Persona.Persona.TipoEstadoCivil.TipoEstadoCivilId
                        "
                      ></C041TiposEstadosCiviles>
                    </div>
                    <div class="form-group col-4">
                      <label for="numeroNomina">Número de Nómina</label>
                      <input
                        v-model="M_Persona.Persona.NumeroNomina"
                        id="numeroNomina"
                        name="numeroNomina"
                        class="form-control"
                        placeholder="Número de Nómina"
                        v-mask="'######'"
                      />
                    </div>
                    <div class="form-group col-4">
                      <label for="sexoCombo">Sexo</label>
                      <C012TiposSexo
                        id="sexoCombo"
                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                        :tipo="enumeraciones.tiposDeSelect.Seleccione"
                        :valorDefinido="M_Persona.Persona.TipoSexo.TipoSexoId"
                        v-on:valorParaElPadre="cambioDeTipoSexo"
                        :key="M_Persona.Persona.TipoSexo.TipoSexoId"
                        :parametros="{}"
                      ></C012TiposSexo>
                    </div>
                  </div>
                  <!-- Fecha de nacimiento-->
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="fechaNacimientoPersona"
                        >Fecha de nacimiento:</label
                      >
                      <input
                        v-model="M_Persona.Persona.FechaNacimiento"
                        id="fechaNacimientoPersona"
                        name="fechaNacimientoPersona"
                        type="date"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-4">
                      <label for="forNumeroDeChecador"
                        >Número de checador:</label
                      >                      
                      <input
                        v-model="M_Persona.Persona.NumeroDeChecador"
                        id="NumeroChecador"
                        name="numero-checador"
                        type="text"
                        class="form-control"
                        v-mask="'######'"
                      />
                    </div>
                  </div>
                  <!--Pais de nacimiento, Entidad federativa de nacimiento, Municipio de nacimiento-->
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="paisDeNacimientoCombo"
                        >País de Nacimiento</label
                      >
                      <C037Paises
                        id="paisDeNacimientoCombo"
                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                        :tipo="enumeraciones.tiposDeSelect.Seleccione"
                        :valorDefinido="
                          this.M_Persona.Persona.PaisDeNacimientoId
                        "
                        v-on:valorParaElPadre="cambioDePaisPeronales"
                        :key="this.M_Persona.Persona.PaisDeNacimientoId"
                      ></C037Paises>
                    </div>

                    <!-- ENTIDAD FEDERATIVA -->
                    <div class="form-group col-4">
                      <label for="entidadFederativaNacimientoCombo"
                        >Entidad Federativa de Nacimiento</label
                      >
                      <C011EntidadesFederativas
                        id="entidadFederativaNacimientoCombo"
                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                        :tipo="enumeraciones.tiposDeSelect.Seleccione"
                        :idDelInput="
                          'altaUsuario_EntidadFederativaNacimiento_Personales'
                        "
                        v-on:valorParaElPadre="
                          cambioDeEntidadFederativaDeNacimiento
                        "
                        :valorDefinido="
                          this.M_Persona.Persona.EntidadFederativa
                            .EntidadFederativaId
                        "
                        :key="
                          this.M_Persona.Persona.EntidadFederativa
                            .EntidadFederativaId
                        "
                      ></C011EntidadesFederativas>
                    </div>

                    <!-- MUNICIPIO -->
                    <div class="form-group col-4">
                      <label for="municipioNacimientoCombo"
                        >Municipio de Nacimiento</label
                      >                      
                      <C010Municipios
                        id="municipioNacimientoCombo"
                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                        :tipo="enumeraciones.tiposDeSelect.Todos"
                        idDelInput="'altaUsuario_MunicipioNacimiento_Personales'"
                        v-on:valorParaElPadre="cambioDeMunicipioDeNacimiento"
                        :valorDefinido="
                          this.M_Persona.Persona.Municipio.MunicipioId
                        "
                        :key="
                          this.M_Persona.Persona.EntidadFederativa
                            .EntidadFederativaId
                        "
                        :parametros="{}"
                        :hereda="
                          this.M_Persona.Persona.EntidadFederativa
                            .EntidadFederativaId
                        "
                      ></C010Municipios>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="telefonoDeCelular">Teléfono Celular</label>
                      <input
                        v-model="M_Persona.Persona.Telefonos[0].NumeroTelefono"
                        id="telefonoDeCelular"
                        name="telefonoDeCelular"
                        class="form-control"
                        placeholder="Teléfono (celular)"
                        v-mask="'##########'"
                      />
                    </div>

                    <div class="form-group col-4">
                      <label for="telefonoDeCasa">Teléfono De Casa</label>
                      <input
                        v-model="M_Persona.Persona.Telefonos[1].NumeroTelefono"
                        id="telefonoDeCasa"
                        name="telefonoDeCasa"
                        class="form-control"
                        placeholder="Teléfono (casa)"
                        v-mask="'##########'"
                      />
                    </div>

                    <div class="form-group col-4">
                      <label for="telefonoOtro">Teléfono Otro</label>
                      <input
                        v-model="M_Persona.Persona.Telefonos[2].NumeroTelefono"
                        id="telefonoOtro"
                        name="telefonoOtro"
                        class="form-control"
                        placeholder="Teléfono (otro)"
                        v-mask="'##########'"
                      />
                    </div>
                  </div>
                  <h5>Domicilio actual</h5>
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="entidadFederativaDeDomicilioCombo"
                        >Entidad Federativa</label
                      >
                      <C011EntidadesFederativas
                        id="entidadFederativaDeDomicilioCombo"
                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                        :tipo="enumeraciones.tiposDeSelect.Seleccione"
                        :idDelInput="
                          'altaUsuario_EntidadFederativaDomicilio_Personales'
                        "
                        v-on:valorParaElPadre="
                          cambioDeEntidadFederativaDeDomicilio
                        "
                        :valorDefinido="this.M_Persona.Persona.Domicilio.EntidadFederativa.EntidadFederativaId"
                        :key="this.M_Persona.Persona.Domicilio.EntidadFederativa.EntidadFederativaId"
                      ></C011EntidadesFederativas>
                    </div>

                    <div class="form-group col-4">
                      <label for="municipioDeDomicilioCombo">Municipio</label>
                      <C010Municipios
                        id="municipioDeDomicilioCombo"
                        :prefijo="enumeraciones.etiquetasDeHTML.Select"
                        :tipo="enumeraciones.tiposDeSelect.Todos"
                        :idDelInput="
                          'altaUsuario_MunicipioDeDomicilio_Personales'
                        "
                        v-on:valorParaElPadre="cambioDeMunicipioDeDomicilio"
                        :valorDefinido="
                          M_Persona.Persona.Domicilio.Municipio.MunicipioId
                        "
                        :hereda="M_Persona.Persona.Domicilio.EntidadFederativa.EntidadFederativaId"
                        :key="M_Persona.Persona.Domicilio.EntidadFederativa.EntidadFederativaId"
                        :parametros="{}"
                      ></C010Municipios>
                    </div>
                    <div class="form-group col-4">
                      <label for="calleDeDomicilio">Calle</label>
                      <input
                        v-model="M_Persona.Persona.Domicilio.Calle"
                        id="calleDeDomicilio"
                        name="calleDeDomicilio"
                        class="form-control"
                        placeholder="Calle"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="numeroExterior">Número Exterior</label>
                      <input
                        v-model="M_Persona.Persona.Domicilio.NumeroExterno"
                        id="numeroExterior"
                        name="numeroExterior"
                        class="form-control"
                        placeholder="Num. Exterior"
                      />
                    </div>
                    <div class="form-group col-4">
                      <label for="numeroInterior">Número Interior</label>
                      <input
                        v-model="M_Persona.Persona.Domicilio.NumeroInterno"
                        id="numeroInterior"
                        name="numeroInterior"
                        class="form-control"
                        placeholder="Num. Interior"
                      />
                    </div>
                    <div class="form-group col-4">
                      <label for="coloniaFraccionamiento"
                        >Colonia/Fraccionamiento</label
                      >
                      <input
                        v-model="M_Persona.Persona.Domicilio.FraccColonia"
                        id="coloniaFraccionamiento"
                        name="coloniaFraccionamiento"
                        class="form-control"
                        placeholder="Colonia/Fraccionamiento"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-4">
                      <label for="codigoPostal">Código Postal</label>
                      <input
                        v-model="M_Persona.Persona.Domicilio.CodigoPostal"
                        id="codigoPostal"
                        name="codigoPostal"
                        class="form-control"
                        placeholder="Código Postal"
                        v-mask="'#####'"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row text-right">
            <!-- Boton de guardado de personal -->
            <div class="form-group col-12">
              <button
                v-on:click="GuardarDatosPersonales"
                id="btnGuardarDatosPersonales"
                class="btn btn-primary"
                :disabled="
                  DesactivaBtnGuardarDatosPersonales ||
                    ValidarCURP(0) ||
                    (!M_Persona.Persona.Activo && M_Persona.Persona.PersonaId)
                "
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
        <!--Contenido del tabulador Academicos-->
        <div
          class="tab-pane fade"
          id="academicos"
          role="tabpanel"
          aria-labelledby="academicos-tab"
        >
          <div class="row">
            <div class="col-12">
              <div class="form-group area">
                <!--Nombre de la institucion, Nivel Academico, Nombre del titulo-->
                <div class="row">
                  <div class="form-group col-6">
                    <label for="nombreDeInstitucion"
                      >Institución Académica</label
                    >
                    <input
                      id="nombreDeInstitucion"
                      v-model="formularioDeEdicionAcademico.NombreInstitucion"
                      name="nombreDeInstitucion"
                      class="form-control"
                      placeholder="Nombre de la institución"
                    />
                  </div>
                  <div class="form-group col-3">
                    <label for="tipoNivelAcademicoId">Nivel Académico</label>
                    <C025TiposNivelAcademico
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      id="tipoNivelAcademicoId"
                      :idDelInput="'altaUsuario_TipoNivelAcademico_Academico'"
                      v-on:valorParaElPadre="cambioTipoNivelAcademico_Academico"
                      :valorDefinido="
                        valorDefinido_TipoNivelAcademico_Academico
                      "
                      :key="valorDefinido_TipoNivelAcademico_Academico"
                    ></C025TiposNivelAcademico>
                  </div>
                  <div class="form-group col-3">
                    <!--<label for="tipoTituloId">Título</label>
                    <C002TipoTitulo
                      id="tipoTituloId"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      :idDelInput="'altaUsuario_TipoTitulo_Academico'"
                      v-on:valorParaElPadre="cambioTipoTitulo_Academico"
                      :valorDefinido="valorDefinido_TipoTitulo_Academico"
                      :key="valorDefinido_TipoTitulo_Academico"
                    ></C002TipoTitulo>-->
                  </div>
                </div>
                <!--Fecha Inicial, Fecha Final-->
                <div class="row">
                  <div class="form-group col-6">
                    <label for="fechaInicialNivelAcademico"
                      >Fecha Inicial:</label
                    >
                    <input
                      v-model="formularioDeEdicionAcademico.FechaInicial"
                      id="fechaInicialNivelAcademico"
                      name="fechaInicialNivelAcademico"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-6">
                    <label for="fechaFinalNivelAcademico">Fecha Final:</label>
                    <input
                      v-model="formularioDeEdicionAcademico.FechaFinal"
                      id="fechaFinalNivelAcademico"
                      name="fechaFinalNivelAcademico"
                      type="date"
                      class="form-control"
                      :disabled="desHabilitaFechaFinalEnAcademicos"
                    />
                  </div>
                </div>
                <!-- Documento Entregado -->
                <div class="row">
                  <div class="form-group col-6">
                    <label for="tipoDocumentoId">Documento</label>
                    <C024TipoDocumento
                      id="tipoDocumentoId"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      :idDelInput="'altaUsuario_TipoDocumento_Academico'"
                      v-on:valorParaElPadre="cambioTipoDocumento_Academico"
                      :valorDefinido="valorDefinido_TipoDocumento_Academico"
                      :key="valorDefinido_TipoDocumento_Academico"
                    ></C024TipoDocumento>
                  </div>
                  <div class="form-group col-6">
                    <label for="ObservacionesAcademicas">Observaciones</label>
                    <textarea
                      class="form-control"
                      name="ObservacionesAcademicas"
                      placeholder="Observaciones"
                      v-model="formularioDeEdicionAcademico.Comentario"
                    ></textarea>
                  </div>
                </div>
                <!-- Cédula Profesional y Botón de Agregar -->
                <div class="row">
                  <div class="form-group col-6 text-left">
                    <label for="CedulaProfesionar">Cédula Profesional</label>
                    <input
                      v-model="formularioDeEdicionAcademico.Cedula"
                      id="cedulaProfesional"
                      name="CedulaProfesionar"
                      class="form-control"
                      placeholder="Cédula Profesional"
                      type="text"
                      v-mask="'########'"
                      v-bind:disabled="deshabilitaCedulaProfesional"
                    />
                  </div>
                  <div class="form-group col-6 text-right">
                    <button
                      v-if="habilitarBotonDeEdicionHistoriaAcademica"
                      v-on:click="ActualizarHistoriaAcademica()"
                      class="btn btn-primary"
                    >
                      Actualizar Información
                    </button>
                    <button
                      v-if="habilitarBotonDeAgregarHistoriaAcademica"
                      v-on:click="AgregarHistoriaAcademica()"
                      class="btn btn-primary"
                    >
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <h5>Historial Académico</h5>
              <div id="tablaAcademico_table" class="table-responsive">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center">Fecha Inicio</th>
                      <th class="text-center">Fecha Fin</th>
                      <th class="text-center">Institucion</th>
                      <th class="text-center">Nivel Academico</th>
                      <!--<th class="text-center">Nombre Titulo</th>-->
                      <th class="text-center">Nombre Documento</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr
                      v-if="
                        M_Persona.Persona.HistoriaAcademica.length <= 0 ||
                          M_Persona.Persona.HistoriaAcademica == undefined ||
                          M_Persona.Persona.HistoriaAcademica == null
                      "
                    >
                      <td colspan="7" class="text-center">
                        No existen registros de Historial Academico
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(HistoriaAcademica,
                      indiceHistoriaAcademica) in M_Persona.Persona
                        .HistoriaAcademica"
                      :key="HistoriaAcademica.HistorialAcademicoId"
                    >
                      <td
                        class="text-center"
                        v-html="
                          obtenFechaConFormatoDDMMYYYY(
                            HistoriaAcademica.FechaInicio
                          )
                        "
                      ></td>
                      <td
                        class="text-center"
                        v-html="
                          obtenFechaConFormatoDDMMYYYY(
                            HistoriaAcademica.FechaFin
                          )
                        "
                      ></td>
                      <td class="text-center">
                        {{ HistoriaAcademica.Institucion }}
                      </td>

                      <td class="text-center">
                        {{
                          HistoriaAcademica != null ||
                          HistoriaAcademica != undefined
                            ? HistoriaAcademica.TipoNivelAcademico.Nombre
                            : ""
                        }}
                      </td>

                      <!--<td class="text-center">
                        {{
                          HistoriaAcademica != null ||
                          HistoriaAcademica != undefined
                            ? HistoriaAcademica.TipoTitulo.Nombre
                            : ""
                        }}
                      </td>-->

                      <td class="text-center">
                        {{
                          HistoriaAcademica != null ||
                          HistoriaAcademica != undefined
                            ? HistoriaAcademica.TipoDocumento.Nombre
                            : ""
                        }}
                      </td>

                      <td class="text-center">
                        <a
                          v-on:click="
                            EditarHistoriaAcademica(
                              HistoriaAcademica,
                              indiceHistoriaAcademica
                            )
                          "
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                        <a
                          v-if="
                            HistoriaAcademica.HistoriaAcademicaId <= 0 ||
                              HistoriaAcademica.HistoriaAcademicaId == null ||
                              HistoriaAcademica.HistoriaAcademicaId == undefined
                          "
                          v-on:click="
                            EliminarHistoriaAcademica(
                              HistoriaAcademica,
                              indiceHistoriaAcademica
                            )
                          "
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <hr />
              <!--boton agregar y guardar-->
              <div class="row text-right">
                <div class="form-group col-12">
                  <button
                    v-if="habilitarBotonGuardarDatosHistoriaAcademica"
                    v-on:click="GuardarDatosAcademicos()"
                    id="btnGuardarDatosPersonales"
                    class="btn btn-primary"
                    v-bind:disabled="
                      !HayRegistrosAcademicos || !M_Persona.Persona.Activo
                    "
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Contenido del tabulador Laborales-->
        <div
          class="tab-pane fade"
          id="laborales"
          role="tabpanel"
          aria-labelledby="laborales-tab"
        >
          <div class="row">
            <div class="col-12">
              <div class="form-group area">
                <!--Área, Departamento, Puesto, Tipo de Puesto-->
                <div class="row">
                  <div class="form-group col-3">
                    <label for="tipoAreaId">Área</label>
                    <C001Area
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Todas"
                      id="tipoAreaId"
                      :idDelInput="'altaUsuario_AreaHistoriaLaboral_Laborales'"
                      v-on:valorParaElPadre="cambioAreaHistorialLaboral"                      
                      :valorDefinido="this.datosLocales[0].valor.Id"
                      :key="this.datosLocales[0].valor.Id"
                      :parametros="{}"
                    ></C001Area>
                  </div>
                  <div class="form-group col-3">
                    <label for="departamentoId">Departamento</label>
                    <C039TiposDepartamento
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      id="departamentoId"
                      :idDelInput="'altaUsuario_TipoDepartamento_Laboral'"
                      v-on:valorParaElPadre="cambioTipoDepartamentoLaboral"
                      :valorDefinido="this.datosLocales[1].valor.Id"
                      :local="{
                        Id: this.datosLocales[1].Id,
                        valor: this.datosLocales[1].valor.Id
                      }"
                      :hereda="this.datosLocales[0].valor.Id"
                      :key="this.datosLocales[0].valor.Id"
                    ></C039TiposDepartamento>
                  </div>
                  <div class="form-group col-3">
                    <label for="tipoPuestoId">Puesto</label>
                    <C045Puestos
                      id="tipoPuestoId"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      :idDelInput="'altaUsuario_Puesto_Laboral'"
                      v-on:valorParaElPadre="cambioTipoPuestoLaboral"
                      :valorDefinido="this.datosLocales[2].valor.Id"
                      :local="{
                        Id: this.datosLocales[2].Id,
                        valor: this.datosLocales[2].valor.Id
                      }"
                      :key="this.datosLocales[1].valor.Id"
                      :hereda="this.datosLocales[1].valor.Id"
                      :parametros="{
                        AreaId: this.datosLocales[0].valor.Id,
                        DepartamentoId: this.datosLocales[1].valor.Id
                      }"
                    ></C045Puestos>
                  </div>
                  <div class="form-group col-3">
                    <label for="tipoPlazaId">Tipo Plaza</label>
                    <C028TiposPlaza
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      id="tipoPlazaId"
                      :idDelInput="'altaUsuario_TipoPlaza_Laboral'"
                      v-on:valorParaElPadre="cambioTipoPlazaLaboral"
                      :local="{
                        Id: this.datosLocales[3].Id,
                        valor: this.datosLocales[3].valor.Id
                      }"
                      :valorDefinido="this.datosLocales[3].valor.Id"
                      :key="this.datosLocales[3].valor.Id"
                    ></C028TiposPlaza>
                  </div>
                </div>
                <!--Fecha Inicial, Fecha final-->
                <div class="row">
                  <div class="form-group col-6">
                    <label for>Fecha Inicial:</label>
                    <input
                      v-model="fechaInicialPeriodoLaboral"
                      id="fechaInicialPeriodoLaboral"
                      name="fechaInicialPeriodoLaboral"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-6">
                    <label for>Fecha Final:</label>
                    <input
                      v-model="fechaFinalPeriodoLaboral"
                      id="fechaFinalPeriodoLaboral"
                      name="fechaFinalPeriodoLaboral"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
                <!-- Tipo de Movimiento -->
                <div class="row">
                  <div class="form-group col-4">
                    <label for="tipoMovimientoId">Tipo Movimiento</label>
                    <C022TiposMovimiento
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      id="tipoMovimientoId"
                      :idDelInput="'altaUsuario_TipoMovimiento_Laboral'"
                      v-on:valorParaElPadre="cambioTipoMovimientoLaboral"
                      :valorDefinido="
                        this.parametros_TipoMovimiento_Laborales.Id
                      "
                      :key="this.parametros_TipoMovimiento_Laborales.Id"
                    ></C022TiposMovimiento>
                  </div>
                  <div class="form-group col-4">
                    <label for="tipoTurnoCombo">Turno</label>
                    <C003TiposTurno
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      id="tipoTurnoCombo"
                      :idDelInput="'altaUsuario_TipoTurno_Laboral'"
                      v-on:valorParaElPadre="cambioTipoTurnoLaboral"
                      :local="{
                        Id: this.datosLocales[4].Id,
                        valor: this.datosLocales[4].valor.Id
                      }"
                      :valorDefinido="this.datosLocales[4].valor.Id"
                      :key="datosLocales[4].valor.Id"
                    ></C003TiposTurno>
                  </div>
                  <div class="form-group col-4">
                    <label for="tipoContratoCombo">Tipo Contrato</label>
                    <C027TiposContrato
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      id="tipoContratoCombo"
                      :idDelInput="'altaUsuario_TipoContrato_Laboral'"
                      v-on:valorParaElPadre="cambioTipoContratoLaboral"
                      :valorDefinido="this.parametros_TipoContrato_Laborales.Id"
                      :key="this.parametros_TipoContrato_Laborales.Id"
                    ></C027TiposContrato>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-4">
                    <input id="causoBaja" type="checkbox" v-model="causoBaja">
                    <label for="causoBaja">Causó baja</label>
                  </div>
                </div>
                <!-- Boton Agregar y Editar -->
                <div class="row text-right">
                  <div class="form-group col-12">
                    <button
                      v-if="habilitarBotonAgregarHistorialLaboral"
                      v-on:click="AgregarHistoriaLaboral()"
                      id="btnAgregarHistoriaLaboral"
                      class="btn btn-primary"
                    >
                      Agregar
                    </button>
                    <button
                      v-if="habilitarBotonEdicionLaboral"
                      v-on:click="ActualizarHistoriaLaboral()"
                      class="btn btn-primary"
                    >
                      Actualizar Información
                    </button>
                  </div>
                </div>
              </div>
              <h5>Historial Laboral</h5>
              <div id="tablaLaboral_table" class="table-responsive">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center">Fecha Inicio</th>
                      <th class="text-center">Fecha Fin</th>
                      <th class="text-center">Área</th>
                      <th class="text-center">Departamento</th>
                      <th class="text-center">Puesto</th>
                      <th class="text-center">Movimiento</th>
                      <th class="text-center">Causó baja</th>
                      <th class="text-center">Plaza</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr
                      v-if="
                        M_Persona.Persona.HistorialLaboral.length <= 0 ||
                          M_Persona.Persona.PersonaId == null
                      "
                    >
                      <td colspan="8" class="text-center">
                        No existen registros de Historial Laboral
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(HistoriaLaboral,
                      indiceHistoriaLaboral) in M_Persona.Persona
                        .HistorialLaboral"
                      :key="HistoriaLaboral.HistoriaLaboralId"
                    >
                      <td
                        class="text-center"
                        v-html="
                          obtenFechaConFormatoDDMMYYYY(
                            HistoriaLaboral.FechaInicial
                          )
                        "
                      ></td>
                      <td
                        class="text-center"
                        v-html="
                          obtenFechaConFormatoDDMMYYYY(
                            HistoriaLaboral.FechaFinal
                          )
                        "
                      ></td>

                      <td class="text-center">
                        {{
                          HistoriaLaboral.EstructuraOrganica
                            .TipoDepartamentoArea.Area != null ||
                          HistoriaLaboral.EstructuraOrganica
                            .TipoDepartamentoArea.Area != undefined
                            ? HistoriaLaboral.EstructuraOrganica
                                .TipoDepartamentoArea.Area.Nombre
                            : "Sin Area"
                        }}
                      </td>

                      <td class="text-center">
                        {{
                          HistoriaLaboral.EstructuraOrganica
                            .TipoDepartamentoArea.TipoDepartamento != null ||
                          HistoriaLaboral.EstructuraOrganica
                            .TipoDepartamentoArea.TipoDepartamento != undefined
                            ? HistoriaLaboral.EstructuraOrganica
                                .TipoDepartamentoArea.TipoDepartamento.Nombre
                            : "Sin Departamento"
                        }}
                      </td>
                      <td class="text-center">
                        {{
                          HistoriaLaboral.EstructuraOrganica != null ||
                          HistoriaLaboral.EstructuraOrganica != undefined
                            ? HistoriaLaboral.EstructuraOrganica.Puesto.Nombre
                            : "Sin Puesto"
                        }}
                      </td>
                      <td class="text-center">
                        {{ HistoriaLaboral.TipoMovimiento.NombreMovimiento }}
                      </td>
                      
                      <td class="text-center">
                        {{ HistoriaLaboral.CausoBaja != true
                          ? "No"
                          : "Sí" }}
                      </td>

                      <td class="text-center">
                        {{
                          HistoriaLaboral.EstructuraOrganica.TipoPlaza !=
                            null ||
                          HistoriaLaboral.EstructuraOrganica.TipoPlaza !=
                            undefined
                            ? HistoriaLaboral.EstructuraOrganica.TipoPlaza
                                .Nombre
                            : "Sin Plaza"
                        }}
                      </td>

                      <td class="text-center">
                        <a
                          v-on:click="
                            EditarHistoriaLaboral(
                              HistoriaLaboral,
                              indiceHistoriaLaboral
                            )
                          "
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                        <a
                          v-if="
                            HistoriaLaboral.HistoriaLaboralId <= 0 ||
                              HistoriaLaboral.HistoriaLaboralId == null ||
                              HistoriaLaboral.HistoriaLaboralId == undefined
                          "
                          v-on:click="
                            QuitarHistoriaLaboral(indiceHistoriaLaboral)
                          "
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr />
              <div class="row text-right">
                <div class="form-group col-12">
                  <button
                    v-on:click="GuardarDatosLaborales()"
                    id="btnGuardarDatosLaborales"
                    class="btn btn-primary"
                    v-bind:disabled="
                      !HayRegistrosLaborales || !M_Persona.Persona.Activo
                    "
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Contenido del tabulador Superior-->
        <!-- <div
          class="tab-pane fade"
          id="superior"
          role="tabpanel"
          aria-labelledby="superior-tab"
        >
          <div class="row">
            <div class="col-12">
              <div class="form-group area">
                Nivel Academico, Nombre de la institución, Fecha inicial, Fecha final
                <div class="row">
                  <div class="form-group col-6">
                    <label for="Nombredelsuperior">Nombre del Superior</label>
                    <input
                      v-model="nombreSuperiorBusqueda"
                      name="Nombredelsuperior"
                      id="nombreSuperiorA_Buscar"
                      type="text"
                      class="form-control"
                      placeholder="Nombre del superior"
                    />
                  </div>
                  <div class="form-group col-6">
                    <label for="numeroNominaSuperiorBusquedaName"
                      >Número de Nómina</label
                    >
                    <input
                      name="numeroNominaSuperiorBusquedaName"
                      v-model="numeroNominaSuperiorBusqueda"
                      type="text"
                      class="form-control"
                      placeholder="Número de Nómina"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-12 text-right">
                    <button
                      v-on:click="busquedaSuperiores"
                      v-bind:disabled="!nombreSuperiorBusqueda"
                      id="btnBuscarPersonas"
                      class="btn btn-primary"
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div>

              <h5>Resultados de la búsqueda</h5>
              <div class="table-responsive">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center"># de Nómina</th>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Área</th>
                      <th class="text-center">Departamento</th>
                      <th class="text-center">Puesto</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-if="SuperioresEncontrados.length <= 0">
                      <td colspan="6" class="text-center">Sin resultados</td>
                    </tr>
                    <tr
                      v-else
                      v-for="Superior in this.SuperioresEncontrados"
                      :key="Superior.RelacionSuperiorId"
                    >
                      <td class="text-center">{{ Superior.NumeroNomina }}</td>
                      <td class="text-center">
                        {{ Superior.Nombre }}
                        {{ Superior.ApellidoPaterno }}
                        {{ Superior.ApellidoMaterno }}
                      </td>
                      <td class="text-center">{{ Superior.Seccion }}</td>
                      <td class="text-center">{{ Superior.Departamento }}</td>
                      <td class="text-center">{{ Superior.Puesto }}</td>
                      <td class="text-center">
                        <a v-on:click="SolicitarFechaSuperior(Superior)">
                          <i class="fa fa-plus-circle"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr />

              <h5>Superiores</h5>
              <div id="tablaSuperiores" class="table-responsive">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center"># de Nómina</th>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Área</th>
                      <th class="text-center">Departamento</th>
                      <th class="text-center">Puesto</th>
                      <th class="text-center">Fecha Inicial</th>
                      <th class="text-center">Fecha Final</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr
                      v-if="
                        M_Persona.Persona.Superiores.length <= 0 ||
                          M_Persona.Persona.PersonaId == null
                      "
                    >
                      <td colspan="8" class="text-center">
                        No existen registros de Superiores
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(Superior, indiceSuperior) in M_Persona.Persona
                        .Superiores"
                      :key="Superior.RelacionSuperiorId"
                    >
                      <td class="text-center">
                        {{ Superior.Superior.NumeroNomina }}
                      </td>
                      <td class="text-center">
                        {{ Superior.Superior.Nombre }}
                        {{ Superior.Superior.ApellidoPaterno }}
                        {{ Superior.Superior.ApellidoMaterno }}
                      </td>
                      <td class="text-center">
                        {{
                          Superior.Superior.EstructuraOrganica
                            .TipoDepartamentoArea.Area != null
                            ? Superior.Superior.EstructuraOrganica
                                .TipoDepartamentoArea.Area.Nombre
                            : ""
                        }}
                      </td>
                      <td class="text-center">
                        {{
                          Superior.Superior.EstructuraOrganica
                            .TipoDepartamentoArea.TipoDepartamento != null
                            ? Superior.Superior.EstructuraOrganica
                                .TipoDepartamentoArea.TipoDepartamento.Nombre
                            : ""
                        }}
                      </td>
                      <td class="text-center">
                        {{
                          Superior.Superior.EstructuraOrganica.Puesto != null
                            ? Superior.Superior.EstructuraOrganica.Puesto.Nombre
                            : ""
                        }}
                      </td>
                      <td
                        class="text-center"
                        v-html="
                          obtenFechaConFormatoDDMMYYYY(Superior.FechaRegistro)
                        "
                      ></td>
                      <td
                        class="text-center"
                        v-html="
                          obtenFechaConFormatoDDMMYYYY(Superior.FechaFinal)
                        "
                      ></td>
                      <td class="text-center">
                        <a
                          v-if="
                            Superior.RelacionSuperiorId != null ||
                              Superior.RelacionSuperiorId != undefined ||
                              Superior.RelacionSuperiorId > 0
                          "
                          @click="FinalizarPeriodoComoSuperior(Superior)"
                          title="Guardar fecha final como Superior"
                        >
                          <i class="fas fa-unlink"></i>
                        </a>
                        <a
                          v-if="
                            Superior.RelacionSuperiorId == null ||
                              Superior.RelacionSuperiorId == undefined ||
                              Superior.RelacionSuperiorId <= 0
                          "
                          title="Quitar de esta tabla."
                        >
                          <i
                            class="fa fa-trash"
                            @click="QuitarSuperior(indiceSuperior)"
                          />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr />
              <div class="row">
                <div class="col-10"></div>
                <div class="col-2">
                  <input
                    type="button"
                    value="Guardar"
                    class="form-control"
                    @click="GuardarSuperiores"
                    v-bind:disabled="
                      !HayRegistrosDeSuperiores || !M_Persona.Persona.Activo
                    "
                  />
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!--Contenido del tabulador Familiares-->
        <div
          class="tab-pane fade"
          id="familiares"
          role="tabpanel"
          aria-labelledby="familiares-tab"
        >
          <div class="row">
            <div class="col-12">
              <div class="form-group area">
                <div class="row">
                  <div class="form-group col-4">
                    <label for="nombreDeFamiliar">Nombre del familiar</label>
                    <input
                      v-model="formularioDeEdicionFamiliar.Nombre"
                      id="nombreDeFamiliar"
                      name="nombreDeFamiliar"
                      class="form-control"
                      placeholder="Nombre"
                    />
                  </div>
                  <div class="form-group col-4">
                    <label for="apellidoPaternoDeFamiliar"
                      >Apellido Paterno</label
                    >
                    <input
                      v-model="formularioDeEdicionFamiliar.ApellidoPaterno"
                      id="apellidoPaternoDeFamiliar"
                      name="apellidoPaternoDeFamiliar"
                      class="form-control"
                      placeholder="Apellido Paterno"
                    />
                  </div>
                  <div class="form-group col-4">
                    <label for="apellidoMaternoDeFamiliar"
                      >Apellido Materno</label
                    >
                    <input
                      v-model="formularioDeEdicionFamiliar.ApellidoMaterno"
                      id="apellidoMaternoDeFamiliar"
                      name="apellidoMaternoDeFamiliar"
                      class="form-control"
                      placeholder="Apellido Materno"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-4">
                    <label for="telefonoDeFamiliar">Teléfono</label>
                    <input
                      v-model="formularioDeEdicionFamiliar.Telefono"
                      id="telefonoDeFamiliar"
                      name="telefonoDeFamiliar"
                      class="form-control"
                      type="text"
                      placeholder="Teléfono"
                      v-mask="'##########'"
                    />
                  </div>
                  <div class="form-group col-4">
                    <label for="tipoDeParentescoId">Parentesco</label>
                    <C008TiposParentesco
                      id="tipoDeParentescoId"
                      :idDelInput="'altaUsuario_TipoParentesco_Familiares'"
                      :key="valorDefinido_TipoParentesco_Familiares"
                      :valorDefinido="valorDefinido_TipoParentesco_Familiares"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      v-on:valorParaElPadre="cambioTipoParentescoFamiliar"
                    ></C008TiposParentesco>
                  </div>
                  <div class="form-group col-4 text-center">
                    <input
                      v-model="formularioDeEdicionFamiliar.DependienteEconomico"
                      id="dependienteEconomico"
                      type="checkbox"
                      class="form-check-input"
                    />
                    <label for="dependienteEconomico" class="form-check-label"
                      >Dependiente Económico</label
                    >
                  </div>
                  <div class="form-group col-4">
                    <label for>Fecha de nacimiento:</label>
                    <input
                      v-model="formularioDeEdicionFamiliar.FechaDeNacimiento"
                      id="fechaNacimientoDeFamiliar"
                      name="fechaNacimientoDeFamiliar"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-4 text-center">
                    <input
                      v-model="formularioDeEdicionFamiliar.FinadoFamiliar"
                      id="finadoFamiliarID"
                      name="finadoFamiliar"
                      type="checkbox"
                      class="form-check-input"
                    />
                    <label for class="form-check-label">Finado</label>
                  </div>
                </div>
                <h5>Domicilio</h5>
                <!--Pais, Estado, Municipio, Calle-->
                <div class="row">
                  <div class="form-group col-4">
                    <label for="entidadDeDomicioDelFamiliarId"
                      >Entidad Federativa</label
                    >
                    <C011EntidadesFederativas
                      id="entidadDeDomicioDelFamiliarId"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      :idDelInput="
                        'altaUsuario_EntidadFederativaDeDomicilio_Familiares'
                      "
                      v-on:valorParaElPadre="
                        cambioDeEntidadFederativaFamiliares
                      "
                      :valorDefinido="
                        valorDefinido_EntidadFederativaDeDomicilio_Familiares
                      "
                      :key="
                        valorDefinido_EntidadFederativaDeDomicilio_Familiares
                      "
                    ></C011EntidadesFederativas>
                  </div>
                  <div class="form-group col-4">
                    <label for="municipioDeDomicilioDelFamiliarId"
                      >Municipio</label
                    >
                    <C010Municipios
                      id="municipioDeDomicilioDelFamiliarId"
                      :prefijo="enumeraciones.etiquetasDeHTML.Select"
                      :tipo="enumeraciones.tiposDeSelect.Seleccione"
                      :idDelInput="
                        'altaUsuario_MunicipioDeDomicilio_Familiares'
                      "
                      v-on:valorParaElPadre="cambioDeMunicipioFamiliar"

                      :valorDefinido="
                        valorDefinido_MunicipioDeDomicilio_Familiares
                      "
                      :key="
                        this.formularioDeEdicionFamiliar.EntidadFederativaId
                      "
                      :parametros="{}"
                      :hereda="
                        this.formularioDeEdicionFamiliar.EntidadFederativaId
                      "
                    ></C010Municipios>
                  </div>
                  <div class="form-group col-4">
                    <label for="calleDeFamiliar">Calle</label>
                    <input
                      v-model="formularioDeEdicionFamiliar.Calle"
                      id="calleDeFamiliar"
                      name="calleDeFamiliar"
                      class="form-control"
                      placeholder="Calle"
                    />
                  </div>
                </div>
                <!--Numero exterior, Numero Interior, Colonia/Fraccionamiento, Codigo postal-->
                <div class="row">
                  <div class="form-group col-4">
                    <label for="numeroExteriorDeFamiliar"
                      >Número Exterior</label
                    >
                    <input
                      v-model="formularioDeEdicionFamiliar.NumeroExterior"
                      id="numeroExteriorDeFamiliar"
                      name="numeroExteriorDeFamiliar"
                      class="form-control"
                      placeholder="Num. Exterior"
                    />
                  </div>
                  <div class="form-group col-4">
                    <label for="numeroInteriorDeFamiliar"
                      >Número Interior</label
                    >
                    <input
                      v-model="formularioDeEdicionFamiliar.NumeroInterior"
                      id="numeroInteriorDeFamiliar"
                      name="numeroInteriorDeFamiliar"
                      class="form-control"
                      placeholder="Num. Interior"
                      type="text"
                    />
                  </div>
                  <div class="form-group col-4">
                    <label for="coloniaFraccionamientoDeFamiliar"
                      >Colonia/Fraccionamiento</label
                    >
                    <input
                      v-model="
                        formularioDeEdicionFamiliar.ColoniaFraccionamiento
                      "
                      id="coloniaFraccionamientoDeFamiliar"
                      name="coloniaFraccionamientoDeFamiliar"
                      class="form-control"
                      placeholder="Colonia/Fraccionamiento"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-4">
                    <label for="codigoPostalDeFamiliar">Código Postal</label>
                    <input
                      v-model="formularioDeEdicionFamiliar.CodigoPostal"
                      id="codigoPostalDeFamiliar"
                      name="codigoPostalDeFamiliar"
                      class="form-control"
                      placeholder="Código Postal"
                      v-mask="'#####'"
                    />
                  </div>
                </div>
                <!--botones de agregar y guardar-->
                <div class="row text-right">
                  <div class="form-group col-12">
                    <button
                      v-if="habilitarBotonDeAgregarFamiliar"
                      v-on:click="AgregarFamiliar()"
                      id="btnAgregarFamiliar"
                      class="btn btn-primary"
                    >
                      Agregar
                    </button>

                    <button
                      v-if="habilitarBotonDeEdicionDeFamiliar"
                      v-on:click="ActualizarInformacionDeFamiliar()"
                      class="btn btn-primary"
                    >
                      Actualizar Información
                    </button>
                  </div>
                </div>
              </div>
              <h5>Datos Familiares</h5>
              <div id="tablaFamiliares_table" class="table-responsive">
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-dark">
                    <tr>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Apellido Paterno</th>
                      <th class="text-center">Apellido Materno</th>
                      <th class="text-center">Parentesco</th>
                      <th class="text-center">Dependiente Económico</th>
                      <th class="text-center">Finado</th>
                      <th class="text-center">Fecha de Nacimiento</th>
                      <th class="text-center">Domicilio</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr
                      v-if="
                        M_Persona.Persona.Familiares.length <= 0 ||
                          M_Persona.Persona.PersonaId == null
                      "
                    >
                      <td colspan="9" class="text-center">
                        No existen registros de familiares
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(Familiar, indiceDelFamiliar) in M_Persona.Persona
                        .Familiares"
                      :key="Familiar.FamiliarId"
                    >
                      <td class="text-center">{{ Familiar.Nombre }}</td>
                      <td class="text-center">
                        {{ Familiar.ApellidoPaterno }}
                      </td>
                      <td class="text-center">
                        {{ Familiar.ApellidoMaterno }}
                      </td>
                      <td class="text-center">
                        {{ Familiar.TipoParentesco.Nombre }}
                      </td>

                      <td
                        class="text-center"
                        v-if="Familiar.DependienteEconomico"
                      >
                        Sí
                      </td>
                      <td class="text-center" v-else>No</td>
                      
                      <td
                        class="text-center"
                        v-if="Familiar.FinadoFamiliar"
                      >
                        Sí
                      </td>
                      <td class="text-center" v-else>No</td>

                      <td
                        class="text-center"
                        v-html="
                          obtenFechaConFormatoDDMMYYYY(Familiar.FechaNacimiento)
                        "
                      ></td>

                      <td class="text-center" v-if="Familiar.Domicilio">
                        {{ Familiar.Domicilio.Calle
                        }}{{
                          Familiar.Domicilio.NumeroExterno != undefined
                            ? " " + Familiar.Domicilio.NumeroExterno
                            : ""
                        }}{{
                          Familiar.Domicilio.NumeroInterno != undefined
                            ? " " + Familiar.Domicilio.NumeroInterno
                            : ""
                        }}{{
                          Familiar.Domicilio.ColoniaFraccionamiento != undefined
                            ? ", " + Familiar.Domicilio.ColoniaFraccionamiento
                            : ""
                        }}
                      </td>
                      <td class="text-center" v-else>Sin Domicilio</td>

                      <td class="text-center">
                        <a
                          v-on:click="
                            editarFamiliar(Familiar, indiceDelFamiliar)
                          "
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                        <a
                          v-if="
                            Familiar.FamiliarId <= 0 ||
                              Familiar.FamiliarId == null ||
                              Familiar.FamiliarId == undefined
                          "
                          v-on:click="quitarFamiliar(indiceDelFamiliar)"
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr />
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    v-if="habilitarBotonGuardarDatosFamiliares"
                    v-on:click="GuardarDatosFamiliares()"
                    id="btnGuardarDatosFamiliares"
                    class="btn btn-primary"
                    v-bind:disabled="
                      !HayRegistrosDeFamiliares || !M_Persona.Persona.Activo
                    "
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- INICIO DEL MODAL \ ALTA DE SUPERIOR  -->
    <!-- <div
      class="modal fade"
      id="capturaFechaDelSuperior"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ejemploModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ejemploModalLabel">
              Alta de superiores
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Ingrese la fecha desde la cual los involucrados son Superior -
              Subordinado.
            </p>
            <div class="form-group">
              <input
                v-model="fechaInicialComoSuperior"
                type="date"
                class="form-control"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-bind:disabled="!fechaInicialComoSuperior"
              v-on:click="GuardarFechaAltaNuevoSuperior"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- FINAL DEL MODAL \ ALTA DE SUPERIOR   -->

    <!-- INICIO DEL MODAL \ FINALIZAR FECHA DE SUPERIOR  -->
    <!-- <div
      class="modal fade"
      id="capturaFinalizarFechaDelSuperior"
      tabindex="-1"
      role="dialog"
      aria-labelledby="FinalizarFechaModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="FinalizarFechaModalLabel">
              Finalizar fecha como superior
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Ingrese la fecha final desde la cual los involucrados dejaron de
              ser Superior - Subordinado.
            </p>
            <div class="form-group">
              <input
                v-model="fechaFinalComoSuperior"
                type="date"
                class="form-control"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-bind:disabled="!fechaFinalComoSuperior"
              v-on:click="GuardarFechaFinalComoSuperior"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- FIN DEL MODAL \ FINALIZAR FECHA DE SUPERIOR  -->

    <!-- INICIO DEL MODAL -->
    <div
      class="modal fade"
      id="activarPersonaModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="ActivarPersona"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="ActivarPersona">
              Persona desactivada
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              ¿Desea activar a esta perona?
            </p>
            <!-- <div class="form-group">                
                <input v-model="fechaFinalComoSuperior" type="date" class="form-control">                
              </div> -->
          </div>
          <div class="modal-footer">
            <button
              type="button"
              v-on:click="ActivarPersona"
              class="btn btn-primary"
            >
              Activar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN DEL MOMENTO -->
  </div>
</template>

<script>
import catalogos from "@/../static/js/catalogos";
import comun from "@/../static/js/comun";
import enumeraciones from "@/../static/js/enumeraciones";
import api from "@/../static/js/api";
import axios from "axios";
import moment from "moment";
import router from "@/router/index";
import { mapActions } from "vuex";
import VueMask from "v-mask";

//Modelos
import M_Persona from "../Comun/Modelos/Persona";

Vue.use(VueMask);

export default {
  props: ["propCurp"],
  data() {
    return {
      // UTIL
      enumeraciones,
      M_Persona,
      personaVacia: Object,
      formatoDeFechaParaInput: "YYYY-MM-DD",
      formatoDeFechaParaTabla: "DD-MM-YYYY",
      readOnlyCURP: false,
      disableTabAcademicos: true,
      disableTabLaborales: true,
      disableTabSuperiores: true,
      disableTabFamiliares: true,
      activarPersonaDesactivada: false,

      // (2) VARIABLES DEL TABULADOR    __ACADEMICOS__
      indiceFilaEnEdicion_HistorialAcademico: null,
      valorDefinido_TipoNivelAcademico_Academico: -1,
      valorDefinido_TipoTitulo_Academico: -1,
      valorDefinido_TipoDocumento_Academico: -1,
      desHabilitaFechaFinalEnAcademicos: false,

      historialAcademico: {
        HistoriaAcademica: []
      },
      //Variables
      nombreDeInstitucion: "",
      tipoNivelAcademicoId: "",
      nombreNivelAcademico: "",
      tipoTituloId: "",
      nombreTitulo: "",
      fechaInicialNivelAcademico: "",
      fechaFinalNivelAcademico: "",
      tipoDocumentoId: "",
      nombreDocumento: "",
      cedulaProfesional: "",

      filasHistorialAcademico: [],

      // (3) VARIABLES DEL TABULADOR   __LABORALES__
      localLaboralesPuesto: {},

      //Deshabilita por defecto la captura de información del campo cédula profesional
      deshabilitaCedulaProfesional: true,

      parametros_Puesto_TabLaborales: {
        AreaId: null,
        DepartamentoId: null
      },

      valorDefinido_Area_HistorialLaboral: 0,
      valorDefinido_TipoDepartamento_HistorialLaboral: 0,
      valorDefinido_Puesto_HistorialLaboral: -1,
      valorDefinido_TipoPlaza_HistorialLaboral: -1,
      valorDefinido_TipoMovimiento_HistorialLaboral: -1,
      valorDefinido_TipoTurno_HistorialLaboral: -1,
      valorDefinido_TipoContrato_HistorialLaboral: -1,

      // Origen de datos con el que se llena la tabla inferior
      origenDeDatosTablaHistorialLaboral: [],

      // Guarda los valores de la fila en edición
      indiceFilaEnEdicion_HistorialLaboral: null,
      filaEnEdicion_HistorialLaboral: null,

      
      historialLaboral: {
        HistoriaLaboral: [],
        EstructuraOrganica: []
      },
      tipoAreaId: "",
      nombreArea: "",
      departamentoId: "",
      nombreDepartamento: "",
      tipoPuestoId: "",
      nombrePuesto: "",
      tipoPlazaId: "",
      nombrePlaza: "",
      tipoMovimientoId: "",
      nombreMovimiento: "",
      fechaFinalPeriodoLaboral: "",
      fechaInicialPeriodoLaboral: "",
      tipoTurnoId: "",
      nombreTurno: "",
      tipoContratoId: "",
      nombreContrato: "",
      causoBaja: false,

      areaKey: -1,

      // (4) VARIABLES DEL TABULADOR    __SUPERIOR__
      nombreSuperiorABuscar: "",
      areaIdSuperiorABuscar: "",
      departamentoIdABuscar: "",
      puestoIdABuscar: "",
      nombreSuperiorBusqueda: "",
      numeroNominaSuperiorBusqueda: "",
      infoSuperior: {},
      listaSuperiores: [],

      SuperioresEncontrados: [],
      fechaInicialComoSuperior: null,
      fechaFinalComoSuperior: null,
      indiceSuperiorSeleccionado: null,
      presuntoNuevoSuperior: null,
      presuntoSuperiorDadoDeBaja: null,

      // (5) VARIABLES DEL TABULADOR __FAMILIARES__

      indiceDelFamiliarEnEdicion: null,
      indiceDeHistoriaAcademicaEnEdicion: null,

      formularioDeEdicionAcademico: {
        NombreInstitucion: null,
        FechaInicial: null,
        FechaFinal: null,
        Cedula: null,

        TipoNivelAcademicoId: null,
        NombreNivelAcademico: null,

        TipoTituloId: null,
        NombreTipoTitulo: null,

        TipoDocumentoId: null,
        NombreTipoDocumento: null,

        Comentario: null
      },

      formularioDeEdicionFamiliar: {
        PersonaId: null,
        Nombre: null,
        ApellidoPaterno: null,
        ApellidoMaterno: null,
        Telefono: null,

        TipoParentescoFamiliarId: null,
        NombreTipoParentescoFamiliar: null,

        EntidadFederativaId: null,
        EntidadFederativaNombre: null,

        MunicipioId: null,
        MunicipioNombre: null,

        DependienteEconomico: null,
        FechaDeNacimiento: null,
        Calle: null,
        NumeroExterior: null,
        NumeroInterior: null,
        ColoniaFraccionamiento: null,
        CodigoPostal: null,

        FinadoFamiliar: null
      },

      // Valores definidos para elegir con qué opción se cargan los combos
      valorDefinido_TipoParentesco_Familiares: -1,
      valorDefinido_EntidadFederativaDeDomicilio_Familiares: -1,
      valorDefinido_MunicipioDeDomicilio_Familiares: -1,

      //Variable para acceder y establecer valores de los componentes que decidas localmente
      datosLocales: [
        {
          Id: 0,
          key: "Area_TabLaborales",
          valor: {
            Id: 0,
            nombre: null
          }
        },
        {
          Id: 1,
          key: "Departamento_TabLaborales",
          valor: {
            Id: -1,
            nombre: null
          }
        },
        {
          Id: 2,
          key: "Puesto_TabLaborales",
          valor: {
            Id: -1,
            nombre: null
          }
        },
        {
          Id: 3,
          key: "Plaza_TabLaborales",
          valor: {
            Id: -1,
            nombre: null
          }
        },
        {
          Id: 4,
          key: "Turno_TabLaborales",
          valor: {
            Id: -1,
            nombre: null
          }
        }
      ],

      // Listado de objetos
      parametros_TipoEstadoCivil: {
        key: "",
        tipoEstadoCivilId: -1,
        parametros: {}
      },
      parametros_TipoSexo: {
        key: "",
        tipoSexoId: -1,
        parametros: {}
      },
      parametros_Pais_Personales: {
        key: "",
        paisId: -1,
        parametros: {}
      },
      parametros_EntidadFederativaDeNacimiento_Personales: {
        key: "",
        entidadFederativaId: -1,
        parametros: {}
      },
      parametros_MunicipioDeNacimiento_Personales: {
        key: "",
        municipioId: -1,
        parametros: {}
      },
      parametros_EntidadFederativaDeDomicilio_Personales: {
        key: "",
        entidadFederativaId: -1,
        parametros: {}
      },
      parametros_MunicipioDeDomicilio_Personales: {
        key: "",
        municipioId: -1,
        parametros: {}
      },

      // Pestaña(Academico)
      parametros_TipoNivelAcademico_Academico: {
        Id: null,
        Nombre: null
      },
      parametros_TipoTitulo_Academico: {
        Id: null,
        Nombre: null
      },
      parametros_TipoDocumento_Academico: {
        Id: null,
        Nombre: null
      },

      // Pestaña(Laborales)
      parametros_AreaHistorialLaboral_Laborales: {
        Id: null,
        Nombre: null
      },
      parametros_TipoDepartamentoLaboral_Laborales: {
        Id: null,
        Nombre: null
      },
      parametros_TipoPuestoLaboral_Laborales: {
        Id: null,
        Nombre: null
      },
      parametros_TipoPuestoPlaza_Laborales: {
        Id: null,
        Nombre: null
      },
      parametros_TipoMovimiento_Laborales: {
        Id: -1,
        Nombre: null
      },
      parametros_TipoTurno_Laborales: {
        Id: null,
        Nombre: null
      },
      parametros_TipoContrato_Laborales: {
        Id: -1,
        Nombre: null
      },
      parametros_TipoParentesco_Familiares: {
        Id: -1,
        Nombre: null
      },
      parametros_EntidadFederativaDeDomicilio_Familiares: {
        Id: -1,
        Nombre: null
      },
      parametros_MunicipioDeDomicilio_Familiares: {
        Id: -1,
        Nombre: null
      },

      //Variables auxiliares
      existePersona: false,
      noEsPermitidoEditar: true,
      DesactivaBtnGuardarDatosPersonales: true,

      //Controla la visibilidad de los botones de agregar registros a la tabla inferior
      habilitarBotonDeAgregarHistoriaAcademica: true,
      habilitarBotonAgregarHistorialLaboral: true,
      habilitarBotonDeAgregarFamiliar: true,

      //Controla la visibilidad de los botones de edición
      habilitarBotonDeEdicionHistoriaAcademica: false,
      habilitarBotonEdicionLaboral: false,
      habilitarBotonDeEdicionDeFamiliar: false,

      habilitarBotonGuardarDatosFamiliares: true,
      habilitarBotonGuardarDatosHistoriaAcademica: true,
      habilitarBotonGuardarDatosHistorialLaboral: true
    };
  },
  components: {
    C001Area: catalogos.PJ.C001Area,
    C002TipoTitulo: catalogos.SIAP.C002TipoTitulo,
    C012TiposSexo: catalogos.PJ.C012TiposSexo,
    C010Municipios: catalogos.PJ.C010Municipios,
    C011EntidadesFederativas: catalogos.PJ.C011EntidadesFederativas,
    C025TiposNivelAcademico: catalogos.SIAP.C025TiposNivelAcademico,
    C037Paises: catalogos.PJ.C037Paises,
    C041TiposEstadosCiviles: catalogos.PJ.C041TiposEstadosCiviles,
    C024TipoDocumento: catalogos.SIAP.C024TipoDocumento,
    C022TiposMovimiento: catalogos.SIAP.C022TipoMovimiento,
    C003TiposTurno: catalogos.SIAP.C003TipoTurno,
    C028TiposPlaza: catalogos.SIAP.C028TipoPlaza,
    C039TiposDepartamento: catalogos.PJ.C039TipoDepartamento,
    C006PuestoAdministrativo: catalogos.PJ.C006PuestoAdministrativo,
    C045Puestos: catalogos.PJ.C045Puestos,
    C008TiposParentesco: catalogos.SIAP.C008TipoParentesco,
    C027TiposContrato: catalogos.SIAP.C027TipoContrato,
    ModalRedirigeUsuario: catalogos.SIAP.ModalRedirigeUsuario,
    RostroDePersona: catalogos.SIAP.RostroDePersona,
    FirmaAutografa: catalogos.SIAP.FirmaAutografa
  },
  beforeDestroy: function() {
    this.VaciarDatosDePersona();
  },
  mounted: function() {
    //Crea a un clon de persona vacia para cuando se quiera borrar todos los datos del formulario, esté disponible.
    this.personaVacia = new Object(this.M_Persona.Persona);

    // Carga los datos de una persona si se le envia una CURP
    this.propCurp != null && this.propCurp != undefined
      ? this.ValidaSiExisteUsuario(1)
      : false;

    //Configuración necesaria para que el validador (validate.min.js) pueda validar las fechas
    validate.extend(validate.validators.datetime, {
      // The value is guaranteed not to be null or undefined but otherwise it
      // could be anything.
      parse: function(value, options) {
        return +moment.utc(value);
      },
      // Input is a unix timestamp
      format: function(value, options) {
        var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
        return moment.utc(value).format(format);
      }
    });
  },
  computed: {
    HayRegistrosAcademicos: function() {
      return M_Persona.Persona.HistoriaAcademica.length >= 1 ? true : false;
    },
    HayRegistrosLaborales: function() {
      return M_Persona.Persona.HistorialLaboral.length >= 1 ? true : false;
    },
    HayRegistrosDeSuperiores: function() {
      return M_Persona.Persona.Superiores.length >= 1 ? true : false;
    },
    HayRegistrosDeFamiliares: function() {
      return M_Persona.Persona.Familiares.length >= 1 ? true : false;
    }
  },
  methods: {
    obtenFechaConFormatoDDMMYYYY(fecha, formato) {
      formato =
        formato == null || formato == undefined ? "DD-MM-YYYY" : formato;
      return fecha ? moment(fecha).format(formato) : "";
    },
    //Valida que al menos contenga un apellido el PropietarioDeLosApellidos (persona a la que se le desea validar su apellidos)
    UnApellidoObligatorio(ApellidoPaterno, ApellidoMaterno, TipoDePersona) {
      let tieneAlMenosUnApellido = false;
      if (
        (ApellidoPaterno != null &&
          ApellidoPaterno != undefined &&
          ApellidoPaterno != "") ||
        (ApellidoMaterno != null &&
          ApellidoMaterno != undefined &&
          ApellidoMaterno != "")
      ) {
        tieneAlMenosUnApellido = true;
      } else {
        comun.mensajeDeAlerta(
          TipoDePersona + " debe de tener al menos un apellido",
          null,
          null
        );
        tieneAlMenosUnApellido = false;
      }
      return tieneAlMenosUnApellido;
    },
    ValidarCURP(opcion) {
      switch (opcion) {
        // case = 0: Valida la curp sin devolver mensaje al usuario
        case 0:
          return this.M_Persona.Persona.CURP
            ? this.M_Persona.Persona.CURP.length != 18
              ? true
              : false
            : true;
          break;
        default:
          if (this.M_Persona.Persona.CURP.length == 18) {
            return true;
          } else {
            comun.mensajeDeAlerta("CURP invalida.", null, null);
            return false;
          }
          break;
      }
    },
    ActivarNavegacionEntreTabs() {
      this.disableTabAcademicos = false;
      this.disableTabLaborales = false;
      this.disableTabSuperiores = false;
      this.disableTabFamiliares = false;
    },
    VaciarDatosDePersona() {
      comun.SeEstaCargandoInformacion(true);

      // Vacia los formularios y vacía toda la info de la persona
      this.M_Persona.Persona = {
        PersonaId: null,
        Nombre: null,
        NombreCompleto: null,
        ApellidoPaterno: null,
        ApellidoMaterno: null,
        FechaNacimiento: null,
        FechaRegistro: null,
        CorreoElectronico: null,
        RutaImagenRostro: null,
        RutaImagenHuella: null,
        RFC: null,
        CURP: null,
        NSS: null,
        NumeroNomina: null,
        NumeroDeChecador:null,
        Activo: null,
        Puesto: null,
        Departamento: null,
        Seccion: null,
        TipoPlaza: null,
        TipoContrato: null,
        TipoContratoId: null,
        PaisNacimientoId: null,
        TelefonoId: null,
        TipoEstadoCivilId: null,
        SexoId: null,
        DomicilioId: null,
        CuentaBancariaId: null,
        PaisDeNacimientoId: null,
        EntidadDeNacimientoId: null,
        MunicipioDeNacimientoId: null,
        EstructuraOrganicaId: null,
        UsuarioQuienRegistraId: null,
        Domicilio: {
          DomicilioId: null,
          Calle: null,
          CodigoPostal: null,
          NumeroExterno: null,
          NumeroInterno: null,
          FraccColonia: null,
          EntidadesFederativasId: null,
          MunicipiosId: null,
          EntidadFederativa: {
            EntidadFederativaId: -1,
            Nombre: null,
            Codigo: null,
            Activo: null,
            Municipios: null,
            Pais: null
          },
          Municipio: {
            MunicipioId: 0,
            Nombre: null,
            Codigo: null,
            Activo: null,
            EntidadFederativa: null,
            PartidoJudicial: null,
            Areas: []
          }
        },
        EstructuraOrganica: null,
        TipoEstadoCivil: {
          TipoEstadoCivilId: -1,
          Nombre: null
        },
        TipoSexo: {
          TipoSexoId: -1,
          Nombre: null
        },
        Pais: {
          PaisId: 0,
          Nombre: null,
          Codigo: null,
          Activo: null,
          EntidadesFederativas: []
        },
        EntidadFederativa: {
          EntidadFederativaId: -1,
          Nombre: null,
          Codigo: null,
          Activo: null,
          Municipios: null,
          Pais: null
        },
        Municipio: {
          MunicipioId: 0,
          Nombre: null,
          Codigo: null,
          Activo: null,
          EntidadFederativa: null,
          PartidoJudicial: null,
          Areas: []
        },
        Telefonos: [
          {
            TelefonoId: null,
            PersonaId: null,
            NumeroTelefono: 0,
            TipoTelefonoId: null,
            Activo: null,
            UsuarioIdQuienRegistra_001DBCUENTAS: null,
            FechaRegistro: null,
            TipoTelefono: {
              TipoTelefonoId: -1,
              Nombre: null,
              Activo: null
            }
          },
          {
            TelefonoId: null,
            PersonaId: null,
            NumeroTelefono: 0,
            TipoTelefonoId: null,
            Activo: null,
            UsuarioIdQuienRegistra_001DBCUENTAS: null,
            FechaRegistro: null,
            TipoTelefono: {
              TipoTelefonoId: -1,
              Nombre: null,
              Activo: null
            }
          },
          {
            TelefonoId: null,
            PersonaId: null,
            NumeroTelefono: 0,
            TipoTelefonoId: null,
            Activo: null,
            UsuarioIdQuienRegistra_001DBCUENTAS: null,
            FechaRegistro: null,
            TipoTelefono: {
              TipoTelefonoId: -1,
              Nombre: null,
              Activo: null
            }
          }
        ],
        HistoriaAcademica: [],
        HistorialLaboral: [],
        Superiores: [],
        Familiares: [],
        GetNombreCompleto: null
      };

      // Desactiva la navegación a través de los tabs
      this.disableTabAcademicos = true;
      this.disableTabLaborales = true;
      this.disableTabSuperiores = true;
      this.disableTabFamiliares = true;

      // Habilira el formulario inical de captura
      this.DesactivaBtnGuardarDatosPersonales = true;
      this.noEsPermitidoEditar = true;

      // Permite volver a escribir en el input de CURP
      this.readOnlyCURP = false;

      comun.SeEstaCargandoInformacion(false);

      // Se sobrecarga con ese valor por si las dudas y dejarlo muy muy reiniciado
      // el historial de movimientos, lo cual se traduce en limpiar todas las variables
      router.go();
    },
    //Funciones para guardar los datos a base de datos
    GuardarDatosPersonales: function() {      
      comun.SeEstaCargandoInformacion(true);

      //Si la validacion de los campos está correcta
      let datosInvalidos = this.ValidarDatosPersonales();

      // Valida que los datos estén correctos y que tenga al menos un apellido
      if (
        datosInvalidos == undefined &&
        this.UnApellidoObligatorio(
          M_Persona.Persona.ApellidoPaterno,
          M_Persona.Persona.ApellidoMaterno,
          "La persona"
        ) &&
        this.ValidarCURP()
      ) {
        let peticion = {
          Persona: {
            PersonaId: M_Persona.Persona.PersonaId,
            Nombre: M_Persona.Persona.Nombre,
            ApellidoPaterno: M_Persona.Persona.ApellidoPaterno,
            ApellidoMaterno: M_Persona.Persona.ApellidoMaterno,
            FechaNacimiento: M_Persona.Persona.FechaNacimiento,
            CorreoElectronico: M_Persona.Persona.CorreoElectronico.trim(),
            RutaImagenRostro: "",
            RutaImagenHuella: "",
            RFC: M_Persona.Persona.RFC,
            CURP: M_Persona.Persona.CURP,
            NSS: M_Persona.Persona.NSS,
            NumeroNomina: M_Persona.Persona.NumeroNomina,
            NumeroDeChecador: M_Persona.Persona.NumeroDeChecador,
            TelefonoId: "",
            // TipoEstadoCivilId: this.parametros_TipoEstadoCivil.tipoEstadoCivilId,
            TipoEstadoCivil: {
              TipoEstadoCivilId:
                M_Persona.Persona.TipoEstadoCivil.TipoEstadoCivilId
            },
            // SexoId: this.parametros_TipoSexo.tipoSexoId,
            SexoId: M_Persona.Persona.TipoSexo.TipoSexoId,
            Activo: true,
            Pais: {
              PaisId:
                M_Persona.Persona.PaisDeNacimientoId > 0
                  ? M_Persona.Persona.PaisDeNacimientoId
                  : null
            },
            EntidadFederativa: {
              EntidadFederativaId:
                M_Persona.Persona.EntidadFederativa.EntidadFederativaId > 0
                  ? M_Persona.Persona.EntidadFederativa.EntidadFederativaId
                  : null
            },
            Municipio: {
              MunicipioId:
                M_Persona.Persona.Municipio.MunicipioId > 0
                  ? M_Persona.Persona.Municipio.MunicipioId
                  : null
            }
          },
          Telefonos: [],
          Domicilio: {
            DomicilioId: M_Persona.Persona.Domicilio.DomicilioId,
            Calle: M_Persona.Persona.Domicilio.Calle,
            CodigoPostal: M_Persona.Persona.Domicilio.CodigoPostal,
            NumeroExterno: M_Persona.Persona.Domicilio.NumeroExterno,
            NumeroInterno: M_Persona.Persona.Domicilio.NumeroInterno,
            FraccColonia: M_Persona.Persona.Domicilio.FraccColonia,
            EntidadFederativa: {
              EntidadFederativaId:
                M_Persona.Persona.Domicilio.EntidadFederativa
                  .EntidadFederativaId > 0
                  ? M_Persona.Persona.Domicilio.EntidadFederativa
                      .EntidadFederativaId
                  : null
            },
            Municipio: {
              MunicipioId:
                M_Persona.Persona.Domicilio.Municipio.MunicipioId > 0
                  ? M_Persona.Persona.Domicilio.Municipio.MunicipioId
                  : null
            }
          }
        };
        let telefonoCelular = {
          TelefonoId:
            M_Persona.Persona.Telefonos[0] != null
              ? M_Persona.Persona.Telefonos[0].TelefonoId
              : "0",
          NumeroTelefono:
            M_Persona.Persona.Telefonos[0] != null
              ? M_Persona.Persona.Telefonos[0].NumeroTelefono
              : "0",
          TipoTelefonoId: "1"
        };
        peticion.Telefonos.push(telefonoCelular);

        let telefonoDeCasa = {
          TelefonoId:
            M_Persona.Persona.Telefonos[1] != null
              ? M_Persona.Persona.Telefonos[1].TelefonoId
              : "0",
          NumeroTelefono:
            M_Persona.Persona.Telefonos[1] != null
              ? M_Persona.Persona.Telefonos[1].NumeroTelefono
              : "0",
          TipoTelefonoId: "2"
        };
        peticion.Telefonos.push(telefonoDeCasa);

        let telefonoOtro = {
          TelefonoId:
            M_Persona.Persona.Telefonos[2] != null
              ? M_Persona.Persona.Telefonos[2].TelefonoId
              : "0",
          NumeroTelefono:
            M_Persona.Persona.Telefonos[2] != null
              ? M_Persona.Persona.Telefonos[2].NumeroTelefono
              : "0",
          TipoTelefonoId: "3"
        };
        peticion.Telefonos.push(telefonoOtro);

        
        //Hace petición para guardar datos personales
        axios
          .post(
            api.conexion + api.SIAP.funcion.GuardarDatosPersonales,
            peticion,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal
            )
          )
          .then(response => {
            comun.SeEstaCargandoInformacion(false);
            console.log(response);

            if (response.data.SiHayError == false) {
              comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);

              //Setea los ID's de los campos que acaba de crear

              this.M_Persona.Persona.PersonaId =
                response.data.NuevaPersonaCreadaId;

              this.M_Persona.Persona.Domicilio.DomicilioId =
                response.data.NuevoDomicilioCreadoId;
              this.readOnlyCURP = true;

              //Habilita la navegación entre los tabs
              this.ActivarNavegacionEntreTabs();

              this.CargarDatosDePersona(M_Persona.Persona.CURP);
            } else {
              comun.SeEstaCargandoInformacion(false);
              console.error(response);
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            }
          })
          .catch(e => {
            console.error(e);
            comun.SeEstaCargandoInformacion(false);
          });
      }
      //Si no, notifica cuales campos no están correctos
      else {
        comun.SeEstaCargandoInformacion(false);

        //Limpia todas las variables
        //this.M_Persona.Persona = this.personaVacia;
        //this.M_Persona.Persona.CURP = null;
        //this.readOnlyCURP = false;
        //this.DesactivaBtnGuardarDatosPersonales = true;
        //this.noEsPermitidoEditar = true;

        if(datosInvalidos != undefined){
          comun.mensajeDeAlerta("Existe información incompleta en el formulario, revisar faltantes.", null, null);
        }

        // Si hay datos inválidos imprimir en consola
        if (datosInvalidos != undefined) {
          console.error(datosInvalidos);
          let camposInvalidos = Object.getOwnPropertyNames(
            datosInvalidos
          ).sort();
          camposInvalidos.forEach(element => {
            console.log(element.toString());
            let selector = $("#" + element.toString())[0];

            $(selector).popover({
              delay: {
                show: 500,
                hide: 1000
              },
              container: "body",
              placement: "auto",
              trigger: "focus",
              content: "Verificar el formato de este campo"
            });
            $(selector).popover("toggle");
          });
        
        }
      }
    },
    GuardarDatosAcademicos: function() {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        HistoriaAcademica: this.M_Persona.Persona.HistoriaAcademica
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.GuardarDatosAcademicos,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(false);
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            this.M_Persona.Persona.HistoriaAcademica =
              response.data.HistorialAcademico;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    GuardarDatosLaborales: function() {
      comun.SeEstaCargandoInformacion(true);

      let ListaHistorialLaboral = [];

      this.M_Persona.Persona.HistorialLaboral.forEach(HistoriaLaboral => {
        let HistoriaLaboralItem = {
          "PersonaId":null,
            "FechaFinal":null,
            "FechaInicial":null,
          "TipoMovimiento":{
              "TipoMovimientoId":null
            },
          "TipoContrato":{
              "TipoContratoId":null
            },
          "CausoBaja":null,
          "EstructuraOrganica":{
            "TipoPlaza":{
              "TipoPlazaId":null
            },           
            "Puesto":{
              "PuestoId":null
            },
            "TipoDepartamentoArea":{
              "Area":{
                "AreaId":null
              },
              "TipoDepartamento":{
                "TipoDepartamentoId":null
              }
            }
          }
        };
        // Variable HistoriaLaboralId
        HistoriaLaboral.HistoriaLaboralId == null &&
        HistoriaLaboral.HistoriaLaboralId == undefined
          ? (HistoriaLaboralItem.HistoriaLaboralId = null)
          : (HistoriaLaboralItem.HistoriaLaboralId =
              HistoriaLaboral.HistoriaLaboralId);

        HistoriaLaboralItem.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId =
            HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId;

        !!HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento
          ? (HistoriaLaboralItem.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.TipoDepartamentoId 
            = HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.TipoDepartamentoId)
          : (HistoriaLaboralItem.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.TipoDepartamentoId = 0);

        HistoriaLaboralItem.EstructuraOrganica.Puesto.PuestoId =
          HistoriaLaboral.EstructuraOrganica.Puesto.PuestoId;

        HistoriaLaboralItem.FechaInicial = HistoriaLaboral.FechaInicial;

        HistoriaLaboralItem.FechaFinal = HistoriaLaboral.FechaFinal;

        HistoriaLaboralItem.PersonaId = this.M_Persona.Persona.PersonaId;

        HistoriaLaboralItem.TipoMovimiento.TipoMovimientoId =
          HistoriaLaboral.TipoMovimiento.TipoMovimientoId;

        HistoriaLaboralItem.TipoContrato.TipoContratoId =
          HistoriaLaboral.TipoContrato.TipoContratoId;

        HistoriaLaboralItem.CausoBaja = HistoriaLaboral.CausoBaja;

        HistoriaLaboralItem.EstructuraOrganica.TipoPlaza.TipoPlazaId =
         HistoriaLaboral.EstructuraOrganica.TipoPlaza.TipoPlazaId;
        
        ListaHistorialLaboral.push(HistoriaLaboralItem);
        
      });
      
      var peticion = {
        HistoriaLaboral: ListaHistorialLaboral
      };

      axios
        .post(
          api.conexion + api.SIAP.funcion.GuardarDatosLaborales,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(false);
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            this.M_Persona.Persona.HistorialLaboral =
              response.data.HistorialLaboral;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.error(e);
        });
    },
    GuardarDatosSuperiores: function() {
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIAP.funcion.GuardarDatosSuperiores,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(false);
          if (response.data.SiHayError == false) {
            console.log(response);
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
        });
    },
    GuardarDatosFamiliares: function() {      
      comun.SeEstaCargandoInformacion(true);
      let PDatosFamiliares = {
        ListaFamiliares: M_Persona.Persona.Familiares
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.GuardarDatosFamiliares,
          PDatosFamiliares,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(false);
          if (response.data.SiHayError == false) {
            this.M_Persona.Persona.Familiares =
              response.data.Persona.Familiares;
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.error(e);
          comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
        });
    },
    //Funciones para agregar registros a las tablas en la vista
    EliminarHistoriaAcademica: function(
      HistoriaAcademica,
      indiceHistoriaLaboral
    ) {
      M_Persona.Persona.HistoriaAcademica.pop(indiceHistoriaLaboral);
    },
    AgregarHistoriaAcademica: function() {
      let datosInvalidos = this.ValidarDatosAcademicos();
      //Si la validacion de los campos está correcta
      if (datosInvalidos == undefined) {
        if (this.formularioDeEdicionAcademico.TipoDocumentoId == 5) {
          let HistoriaAcademicaCedula = {
            TipoNivelAcademico: {
              TipoNivelAcademicoId: this.formularioDeEdicionAcademico
                .TipoNivelAcademicoId,
              Nombre: this.formularioDeEdicionAcademico.NombreNivelAcademico
            },
            HistoriaAcademicaId: null,
            Institucion: this.formularioDeEdicionAcademico.NombreInstitucion,
            FechaInicio: this.formularioDeEdicionAcademico.FechaInicial,
            FechaFin: this.formularioDeEdicionAcademico.FechaFinal,
            CedulaProfesional: this.formularioDeEdicionAcademico.Cedula,
            PersonaId: this.M_Persona.Persona.PersonaId,
            TipoDocumento: {
              TipoDocumentoId: 4,
              Nombre: "Cédula"
            },            
            Comentario: this.formularioDeEdicionAcademico.Comentario
          };
          let HistoriaAcademicaTitulo = {
            TipoNivelAcademico: {
              TipoNivelAcademicoId: this.formularioDeEdicionAcademico
                .TipoNivelAcademicoId,
              Nombre: this.formularioDeEdicionAcademico.NombreNivelAcademico
            },
            HistoriaAcademicaId: null,
            Institucion: this.formularioDeEdicionAcademico.NombreInstitucion,
            FechaInicio: this.formularioDeEdicionAcademico.FechaInicial,
            FechaFin: this.formularioDeEdicionAcademico.FechaFinal,
            CedulaProfesional: "",
            PersonaId: this.M_Persona.Persona.PersonaId,
            TipoDocumento: {
              TipoDocumentoId: 3,
              Nombre: "Título"
            },
            Comentario: this.formularioDeEdicionAcademico.Comentario
          };
          this.M_Persona.Persona.HistoriaAcademica.push(
            HistoriaAcademicaCedula
          );
          this.M_Persona.Persona.HistoriaAcademica.push(
            HistoriaAcademicaTitulo
          );
        } else {
          let HistoriaAcademica = {
            TipoNivelAcademico: {
              TipoNivelAcademicoId: this.formularioDeEdicionAcademico
                .TipoNivelAcademicoId,
              Nombre: this.formularioDeEdicionAcademico.NombreNivelAcademico
            },
            HistoriaAcademicaId: null,
            Institucion: this.formularioDeEdicionAcademico.NombreInstitucion,
            FechaInicio: this.formularioDeEdicionAcademico.FechaInicial,
            FechaFin: this.formularioDeEdicionAcademico.FechaFinal,
            CedulaProfesional: this.formularioDeEdicionAcademico.Cedula,
            PersonaId: this.M_Persona.Persona.PersonaId,
            TipoDocumento: {
              TipoDocumentoId: this.formularioDeEdicionAcademico
                .TipoDocumentoId,
              Nombre: this.formularioDeEdicionAcademico.NombreTipoDocumento
            },
            Comentario: this.formularioDeEdicionAcademico.Comentario
          };
          this.M_Persona.Persona.HistoriaAcademica.push(HistoriaAcademica);
        }

        //Agrega la nueva historia academica a la persona y por concecuencia a la tabla inferior.
        //this.M_Persona.Persona.HistoriaAcademica.push(HistoriaAcademica);
        this.desHabilitaFechaFinalEnAcademicos = false;
        this.LimpiarFormularioHistorialAcademicoEnEdicion();
      } else {
        console.error(datosInvalidos);
        let camposInvalidos = Object.getOwnPropertyNames(datosInvalidos).sort();
        camposInvalidos.forEach(element => {
          console.log(element.toString());
          let selector = $("#" + element.toString())[0];

          $(selector).popover({
            delay: {
              show: 500,
              hide: 1000
            },
            container: "body",
            placement: "auto",
            trigger: "focus",
            content: "Verificar el formato de este campo"
          });
          $(selector).popover("toggle");
        });
      }
    },

    ///Primero crea la EstructuraOrganica para después agregarle ese id a la HistoriaLaboral
    AgregarHistoriaLaboral: function() {
      let datosInvalidos = this.ValidarDatosLaborales();
      //Si la validacion de los campos está correcta
      if (datosInvalidos == undefined) {
        //Tomar los id's y nombres de los combos para agregarlos a la tabla inferior y al arreglo
        let dataFilaHistorialLaboral = {
          HistoriaLaboralId: null,
          PersonaId: M_Persona.Persona.PersonaId,
          FechaInicial: this.fechaInicialPeriodoLaboral,
          FechaFinal: this.fechaFinalPeriodoLaboral,
          TipoMovimientoId: parseInt(
            this.parametros_TipoMovimiento_Laborales.Id
          ),
          TipoContratoId: parseInt(this.parametros_TipoContrato_Laborales.Id),
          EstructuraOrganica: {
            EstructuraOrganicaId: null,
            TipoTurnoId: parseInt(this.datosLocales[4].valor.Id),
            DepartamentoId: parseInt(this.datosLocales[1].valor.Id),
            Area001DBPJ: parseInt(this.datosLocales[0].valor.Id),
            Puesto: {
              PuestoId: this.datosLocales[2].valor.Id,
              Nombre: this.datosLocales[2].valor.Nombre
            },
            TipoPlazaId: parseInt(this.datosLocales[3].valor.Id),
            TipoTurno: {
              TipoTurnoId: this.parametros_TipoTurno_Laborales.Id
            },
            Puesto: {
              PuestoId: this.datosLocales[2].valor.Id,
              Nombre: this.datosLocales[2].valor.Nombre
            },
            TipoPlaza: {
              TipoPlazaId: this.datosLocales[3].valor.Id,
              Nombre: this.datosLocales[3].valor.Nombre
            },
            TipoDepartamentoArea: {
              TipoDepartamentoAreaId: null,
              Area: {
                AreaId: this.datosLocales[0].valor.Id,
                Nombre: this.datosLocales[0].valor.Nombre
              },
              TipoDepartamento: {
                TipoDepartamentoId: this.datosLocales[1].valor.Id,
                Nombre: this.datosLocales[1].valor.Nombre
              }
            }
          },
          Puesto: this.datosLocales[2].valor.Id,
          TipoMovimiento: {
            TipoMovimientoId: this.parametros_TipoMovimiento_Laborales.Id,
            NombreMovimiento: this.parametros_TipoMovimiento_Laborales.Nombre
          },
          TipoContrato: {
            TipoContratoId: this.parametros_TipoContrato_Laborales.Id
          }
        };

        // Bloque con reglas para agregar una fecha al historial laboral 
        if(this.M_Persona.Persona.HistorialLaboral.length > 0){
          var FechaInicialUltimoPeriodo = this.M_Persona.Persona.HistorialLaboral[0].FechaInicial.toString();
          var FechaFinalUltimoPeriodo = this.M_Persona.Persona.HistorialLaboral[0].FechaFinal;

          var FechaInicialNuevoPeriodo = dataFilaHistorialLaboral.FechaInicial.toString();
          var FechaFinalNuevoPeriodo = dataFilaHistorialLaboral.FechaFinal;
          
          //Valida que si el nuevo registro sea menor al registro más actual
          if(moment(FechaInicialNuevoPeriodo).isBefore(FechaInicialUltimoPeriodo)){
            if(FechaFinalNuevoPeriodo == null){            
              comun.mensajeDeAlerta(
                "Falta agregar una fecha final.",
                null,
                null
              );           
            }
            else{
              // Agrega el objeto al arreglo que contiene lo que se muestra en la tabla del historial laboral
              this.M_Persona.Persona.HistorialLaboral.push(dataFilaHistorialLaboral);

              //Limpia el formulario de alta de un historial laboral
              this.LimpiarFormularioHistorialLaboral();    
            }          
          }
          
          if(this.HayPeriodosConFechasFinalesNulas()){
            comun.mensajeDeAlerta(
                "Hay periodos con fechas finales sin información",
                null,
                null
              ); 
            
          }
          else{
            if(moment(FechaInicialNuevoPeriodo).isAfter(FechaFinalUltimoPeriodo.toString())){ 
              // Agrega el objeto al arreglo que contiene lo que se muestra en la tabla del historial laboral
              this.M_Persona.Persona.HistorialLaboral.push(dataFilaHistorialLaboral);

              //Limpia el formulario de alta de un historial laboral
              this.LimpiarFormularioHistorialLaboral();                 
            }
            else{
              comun.mensajeDeAlerta(
                "La fecha inicial del nuevo periodo no es mayor que la fecha final del último periodo.",
                null,
                null
              );
            }
          }
        }
        else{
          // Agrega el objeto al arreglo que contiene lo que se muestra en la tabla del historial laboral
            this.M_Persona.Persona.HistorialLaboral.push(dataFilaHistorialLaboral);

            //Limpia el formulario de alta de un historial laboral
            this.LimpiarFormularioHistorialLaboral();    
        }
             
      } else {
        let camposInvalidos = Object.getOwnPropertyNames(datosInvalidos).sort();
        camposInvalidos.forEach(element => {
          console.log(element.toString());
          let selector = $("#" + element.toString())[0];

          $(selector).popover({
            delay: {
              show: 500,
              hide: 1000
            },
            container: "body",
            placement: "auto",
            trigger: "focus",
            content: "Verificar el formato de este campo"
          });
          $(selector).popover("toggle");
        });
      }
    },
    HayPeriodosConFechasFinalesNulas: function(){        
      let hayNulo = false;
      this.M_Persona.Persona.HistorialLaboral.forEach(fecha => {        
        if(fecha.FechaFinal == null){          
          hayNulo = true;
          return;
         }
      });
      return hayNulo;
    },
    AgregarFamiliar: function() {
      let datosInvalidos = this.ValidaDatosFamiliares();
      if (
        datosInvalidos == undefined &&
        this.UnApellidoObligatorio(
          this.formularioDeEdicionFamiliar.ApellidoPaterno,
          this.formularioDeEdicionFamiliar.ApellidoMaterno,
          "El familiar"
        )
      ) {
        let nuevoFamiliar = {
          FamiliarId: null,
          PersonaId: M_Persona.Persona.PersonaId,
          Nombre: this.formularioDeEdicionFamiliar.Nombre,
          ApellidoPaterno: this.formularioDeEdicionFamiliar.ApellidoPaterno,
          ApellidoMaterno: this.formularioDeEdicionFamiliar.ApellidoMaterno,
          Telefono: this.formularioDeEdicionFamiliar.Telefono,
          FechaNacimiento: this.formularioDeEdicionFamiliar.FechaDeNacimiento,
          
          DependienteEconomico: this.formularioDeEdicionFamiliar.DependienteEconomico,
          FinadoFamiliar: this.formularioDeEdicionFamiliar.FinadoFamiliar,

          TipoParentesco: {
            TipoParentescoId: this.parametros_TipoParentesco_Familiares.Id,
            Nombre: this.parametros_TipoParentesco_Familiares.Nombre
          },

          Domicilio: {
            Calle: this.formularioDeEdicionFamiliar.Calle,
            NumeroExterno: this.formularioDeEdicionFamiliar.NumeroExterior,
            NumeroInterno: this.formularioDeEdicionFamiliar.NumeroInterior,
            FraccColonia: this.formularioDeEdicionFamiliar
              .ColoniaFraccionamiento,
            CodigoPostal: this.formularioDeEdicionFamiliar.CodigoPostal,

            EntidadFederativa: {
              EntidadFederativaId: this.formularioDeEdicionFamiliar
                .EntidadFederativaId
            },
            Municipio: {
              MunicipioId: this.formularioDeEdicionFamiliar.MunicipioId
            }
          }
        };

        if (M_Persona.Persona.Familiares != null) {
          M_Persona.Persona.Familiares.push(nuevoFamiliar);
        }

        this.LimpiarFormularioFamiliarEnEdicion();
      } else {
        console.log("datos invalidos ->");
        console.log(datosInvalidos);
        let camposInvalidos = Object.getOwnPropertyNames(datosInvalidos).sort();
        camposInvalidos.forEach(element => {
          console.log(element.toString());
          let selector = $("#" + element.toString())[0];

          $(selector).popover({
            delay: {
              show: 500,
              hide: 1000
            },
            container: "body",
            placement: "auto",
            trigger: "focus",
            content: "Verificar el formato de este campo"
          });
          $(selector).popover("toggle");
        });
      }
    },

    //Validadores de variables. Los contraints tienen las reglas que se le aplicaran al valor.
    ValidarDatosPersonales: function() {
      let constraints = {
        nombrePersona: {
          presence: {
            message: "Valor=%{value}. No se permite el campo vacío."
          },
          type: "string"
        },
        apellidoPaterno: {
          // presence:{
          //   message:"Valor=%{value}. No se permite el campo vacío."
          // },
          // type: "string"
        },
        apellidoMaterno: {
          // presence:{
          //   message:"Valor=%{value}. No se permite el campo vacío."
          // },
          // type: "string"
        },
        correoElectronico: {
          email: {
            message: "(%{value}), no es correcto, verifique por favor."
          }
        },
        // RFC: {
        //   presence: {
        //     message: "Valor=%{value}. No se permite el campo vacío."
        //   }
        // },
        CURP: {
          presence: {
            message: "Valor=%{value}. No se permite el campo vacío."
          }
        },
        // NSS: {
        //   presence: {
        //     message: "Value=%{value} Es obligatorio"
        //   }
        // },
        tipoEstadoCivilCombo: {
          presence: {
            message: "Valor=%{value}. No se permite el campo vacío."
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Valor=%{value}. Debe de elegir una opción"
          }
        },
        numeroNomina: {
          // presence: {
          //   message: "Valor=%{value}. No se permite el campo vacío."
          // }
        },
        sexoCombo: {
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Valor=%{value}. Debe de elegir una opción."
          }
        },
        fechaNacimientoPersona: {
          datetime: {
            dateOnly: true,
            message: "Formato de fecha incorrecto"
          }
        },
        paisDeNacimientoCombo: {
          // presence: {
          //   message:"Valor=[%{value}]. Debe elegir una opción."
          // },
          // numericality: {
          //   onlyInteger: true,
          //   greaterThan: 0,
          //   message: "Valor=[%{value}]. Debe de elegir una opción"
          // }
        },
        entidadFederativaNacimientoCombo: {
          // presence:{
          //   message:'%{value}. Valor obligatorio'
          // },
          // numericality: {
          //   onlyInteger: true,
          //   greaterThan: 0,
          //   message: "Valor=%{value}. Debe de elegir una opción."
          // }
        },
        municipioNacimientoCombo: {
          // presence: true,
          // numericality: {
          //   onlyInteger: true,
          //   greaterThan: 0,
          //   message: "Valor=%{value}. Debe de elegir una opción."
          // }
        },
        telefonoDeCelular: {
          // length: {
          //   is: 10,
          //   message:
          //     "(%{value}) Longitud de teléfono celular incorrecta (Deben ser 10 dígitos)"
          // }
        },
        telefonoDeCasa: {
          // length: {
          //   is: 10,
          //   message:
          //     "(%{value}) Longitud de teléfono de casa incorrecta (Deben ser 10 dígitos)"
          // }
        },
        telefonoOtro: {
          // length: {
          //   is: 10,
          //   message: "(%{value}) Longitud de teléfono incorrecto (Deben ser 10 dígitos)"
          // }
        },
        entidadFederativaDeDomicilioCombo: {
          presence: {
            message: "Valor=%{value}. No se permite el campo vacío."
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe de elegir una opción"
          }
        },
        municipioDeDomicilioCombo: {
          presence: {
            message: "Valor=%{value}. No se permite el campo vacío."
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Valor=%{value}. Debe de elegir una opción."
          }
        },
        calleDeDomicilio: {
          presence: {
            message: "Valor=%{value}. No se permite el campo vacío."
          }
        },
        numeroExterior: {
          // presence:{
          //   message:"Valor=%{value}. No se permite el campo vacío."
          // },
          // numericality: {
          //   onlyInteger: true,
          //   greaterThan: 0,
          //   message: "El valor (%{value}) dede de ser mayor a cero"
          // }
          type: "string"
        },
        numeroInterior: {
          type: "string"
        },
        coloniaFraccionamiento: {
          presence: {
            message: "Valor=%{value}. No se permite el campo vacío."
          }
        },
        codigoPostal: {
          // presence:{
          //   message:"Valor=%{value}. No se permite el campo vacío."
          // }
        }
      };

      let datosPersonales = {
        nombrePersona: M_Persona.Persona.Nombre,
        apellidoPaterno: M_Persona.Persona.ApellidoPaterno,
        apellidoMaterno: M_Persona.Persona.ApellidoMaterno,
        correoElectronico: M_Persona.Persona.CorreoElectronico.trim(),
        //RFC: M_Persona.Persona.RFC,
        CURP: M_Persona.Persona.CURP,
        //NSS: M_Persona.Persona.NSS,
        tipoEstadoCivilCombo:
          M_Persona.Persona.TipoEstadoCivil.TipoEstadoCivilId,
        numeroNomina: M_Persona.Persona.NumeroNomina,
        sexoCombo: M_Persona.Persona.TipoSexo.TipoSexoId,
        fechaNacimientoPersona: M_Persona.Persona.FechaNacimiento,
        paisDeNacimientoCombo: M_Persona.Persona.PaisDeNacimientoId,
        entidadFederativaNacimientoCombo: this.M_Persona.Persona
          .EntidadFederativa.EntidadFederativaId,
        // entidadFederativaNacimientoCombo: -1,
        municipioNacimientoCombo: M_Persona.Persona.Municipio.MunicipioId,
        telefonoDeCelular:
          M_Persona.Persona.Telefonos[0] != null
            ? M_Persona.Persona.Telefonos[0].NumeroTelefono
            : "0",
        telefonoDeCasa:
          M_Persona.Persona.Telefonos[1] != null
            ? M_Persona.Persona.Telefonos[1].NumeroTelefono
            : "0",
        telefonoOtro:
          M_Persona.Persona.Telefonos[2] != null
            ? M_Persona.Persona.Telefonos[2].NumeroTelefono
            : "0",
        // entidadFederativaDeDomicilioCombo: this.parametros_EntidadFederativaDeDomicilio_Personales.entidadFederativaId,
        entidadFederativaDeDomicilioCombo: this.M_Persona.Persona.Domicilio
          .EntidadFederativa.EntidadFederativaId,
        // entidadFederativaDeDomicilioCombo: -1,
        municipioDeDomicilioCombo:
          M_Persona.Persona.Domicilio.Municipio.MunicipioId,
        calleDeDomicilio: M_Persona.Persona.Domicilio.Calle,
        numeroExterior: M_Persona.Persona.Domicilio.NumeroExterior,
        numeroInterior: M_Persona.Persona.Domicilio.NumeroInterior,
        coloniaFraccionamiento: M_Persona.Persona.Domicilio.FraccColonia,
        codigoPostal: M_Persona.Persona.Domicilio.CodigoPostal
      };
      let resultado = validate(datosPersonales, constraints);
      return resultado;
    },
    ValidarDatosAcademicos: function() {
      let constraints = {
        nombreDeInstitucion: {
          presence: {
            allowEmpty: true,
            message: "No se permiten campos vacíos."
          }
          // format: {
          //   pattern: "^[a-zA-Z0-9. ]*$",
          //   message: "Formato de entrada invalido."
          // }
        },
        tipoNivelAcademicoId: {
          presence: {
            message: "Valor=%{value}. No debe estar vacío."
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe de elegir una opción"
          }
        },
        // tipoTituloId: {
        //   presence: {
        //     message: "Valor=%{value}. No debe estar vacío."
        //   },
        //   numericality: {
        //     onlyInteger: true,
        //     greaterThan: 0,
        //     message: "Debe de elegir una opción"
        //   }
        // },
        fechaInicialNivelAcademico: {
          presence: {
            message: "Valor=%{value}. No debe estar vacío."
          },
          datetime: {
            dateOnly: true,
            message: "Formato de fecha incorrecto"
          }
        },
        fechaFinalNivelAcademico: {
          // presence:{
          //   message: "Valor=%{value}. No debe estar vacío."
          // },
          // datetime: {
          //   dateOnly: true,
          //   message: "Formato de fecha incorrecto"
          // }
        },
        tipoDocumentoId: {
          presence: {
            message: "Valor=%{value}. No debe estar vacío."
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe de elegir una opción"
          }
        },
        cedulaProfesional: {
          // presence:{
          //   message: "Valor=%{value}. No debe estar vacío."
          // },
          // length: {
          //   is: 8,
          //   message: "valor=[%{value}]. Debe de tener una longitud de 8 caracteres."
          // }
        }
      };
      let datosAcademicos = {
        nombreDeInstitucion: this.formularioDeEdicionAcademico
          .NombreInstitucion,
        tipoNivelAcademicoId: this.formularioDeEdicionAcademico
          .TipoNivelAcademicoId,
        tipoTituloId: this.formularioDeEdicionAcademico.TipoTituloId,
        fechaInicialNivelAcademico: this.formularioDeEdicionAcademico
          .FechaInicial,
        fechaFinalNivelAcademico: this.formularioDeEdicionAcademico.FechaFinal,
        tipoDocumentoId: this.formularioDeEdicionAcademico.TipoDocumentoId,
        cedulaProfesional: this.formularioDeEdicionAcademico.Cedula
      };

      let resultado = validate(datosAcademicos, constraints);
      return resultado;
    },
    ValidarDatosLaborales: function() {
      let constraints = {
        tipoAreaId: {
          presence: {
            message: "Valor evaluado (%{value}). Debe elegir una opción."
          }
          // numericality: {
          //   onlyInteger: true,
          //   greaterThan: -2,
          //   message: "Debe de elegir una opción"
          // }
        },
        departamentoId: {
          presence: {
            message: "Valor evaluado (%{value}). Debe elegir una opción."
          }
          // numericality: {
          //   onlyInteger: true,
          //   greaterThan: 0,
          //   message: "Debe de elegir una opción"
          // }
        },
        tipoPuestoId: {
          presence: {
            message: "Valor (%{value}). Debe elegir una opción."
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe de elegir una opción"
          }
        },
        tipoPlazaId: {
          presence: {
            message: "Valor (%{value}). Debe elegir una opción."
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe de elegir una opción"
          }
        },
        fechaInicialPeriodoLaboral: {
          datetime: {
            dateOnly: true,
            message: "Formato de fecha incorrecto"
          }
        },
        fechaFinalPeriodoLaboral: {
          // datetime: {
          //   dateOnly: true,
          //   message: "Formato de fecha incorrecto"
          // }
        },
        tipoMovimientoId: {
          presence: {
            message: "Valor (%{value}). Debe elegir una opción"
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe ser un numero"
          }
        },
        tipoTurnoId: {
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe de elegir una opción"
          }
        },
        tipoTurnoCombo: {
          presence: {
            message: "Valor (%{value}). Debe elegir una opción"
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe ser un numero"
          }
        },
        tipoContratoCombo: {
          presence: {
            message: "Valor (%{value}). Debe elegir una opción"
          },
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe ser un numero"
          }
        }
      };

      let resultado = validate(
        {
          // tipoAreaId: this.parametros_AreaHistorialLaboral_Laborales.Id,
          // departamentoId: this.parametros_TipoDepartamentoLaboral_Laborales.Id,
          // tipoPuestoId: this.localLaboralesPuesto.Id,
          tipoAreaId: this.datosLocales[0].valor.Id,
          departamentoId: this.datosLocales[1].valor.Id,
          tipoPuestoId: this.datosLocales[2].valor.Id,
          tipoPlazaId: this.datosLocales[3].valor.Id,
          fechaInicialPeriodoLaboral: this.fechaInicialPeriodoLaboral,
          fechaFinalPeriodoLaboral: this.fechaFinalPeriodoLaboral,
          tipoMovimientoId: this.parametros_TipoMovimiento_Laborales.Id,
          tipoTurnoCombo: this.datosLocales[4].valor.Id,
          tipoContratoCombo: this.parametros_TipoContrato_Laborales.Id
        },
        constraints
      );
      return resultado;
    },
    ValidarDatosSuperiores: function() {
      let constraints = {
        nombreSuperiorABuscar: {
          presence: {
            allowEmpty: false
          },
          format: {
            pattern: "^[a-zA-Z. ]*$",
            message: "Este campo no acepta números."
          }
        }
      };
      let resultado = validate(
        {
          nombreSuperiorABuscar: this.nombreSuperiorABuscar
        },
        constraints
      );
      return resultado;
    },
    ValidaDatosFamiliares: function() {
      let constraints = {
        nombreDeFamiliar: {
          presence: {
            allowEmpty: false,
            message: "No se permiten campos vacíos"
          }
          // format: {
          //   pattern: "^[a-zA-Z. ]*$",
          //   message: "Formato de entrada no válido."
          // }
        },
        apellidoPaternoDeFamiliar: {
          // presence: {
          //   allowEmpty: false,
          //   message: "No se permiten campos vacíos."
          // }
          // format: {
          //   pattern: "^[a-zA-Z. ]*$",
          //   message: "Formato de entrada inválido."
          // }
        },
        apellidoMaternoDeFamiliar: {
          // presence: {
          //   allowEmpty: false,
          //   message: "No se permiten campos vacíos."
          // }
          // format: {
          //   pattern: "^[a-zA-Z. ]*$",
          //   message: "Formato de entrada inválido."
          // }
        },
        telefonoDeFamiliar: {
          // length: {
          //   maximum: 10,
          //   message:
          //     "Longitud de teléfono celular incorrecta (Deben ser al menos 10 dígitos)"
          // },
          // numericality: {
          //   onlyInteger: true,
          //   message: "Introducir solo números."
          // }
        },
        tipoDeParentescoId: {
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe de elegir una opción"
          },
          presence: {
            message: "Valor:(%{value}) Mensaje:Debe elegir una opcion"
          }
        },
        fechaNacimientoDeFamiliar: {
          datetime: {
            dateOnly: true,
            message: "Valor:(%{value}). Formato de fecha incorrecto"
          }
        },
        entidadDeDomicioDelFamiliarId: {
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Valor:(%{value}) Mensaje:Debe de elegir una opción"
          },
          presence: {
            message: "Valor:(%{value}) Mensaje:Debe elegir una opcion"
          }
        },
        municipioDeDomicilioDelFamiliarId: {
          numericality: {
            onlyInteger: true,
            greaterThan: 0,
            message: "Debe de elegir una opción"
          },
          presence: {
            message: "Valor:(%{value}) Mensaje:Debe elegir una opcion"
          }
        },
        calleDeFamiliar: {
          // presence: {
          //   allowEmpty: false,
          //   message: "No puede ir vacío este campo"
          // }
          // format: {
          //   pattern: "^[a-zA-Z0-9. ]*$",
          //   message: "Este campo no acepta números."
          // }
        },
        numeroExteriorDeFamiliar: {
          // presence: {
          //   allowEmpty: false,
          //   message: "No se permite el campo vacio"
          // },
          // numericality: {
          //   onlyInteger: true,
          //   greaterThan: 0,
          //   message: "Dede de ser mayor a cero"
          // }
        },
        numeroInteriorDeFamiliar: {
          // presence: false
        },
        coloniaFraccionamientoDeFamiliar: {
          // presence: {
          //   allowEmpty: false
          // }
          // format: {
          //   pattern: "^[a-zA-Z. ]*$",
          //   message: "Formato incorrecto"
          // }
        },
        codigoPostalDeFamiliar: {
          // presence:{
          //   message:"Valor:(%{value}). No debe ser vacío."
          // },
          // length: {
          //   is: 5,
          //   message: "Formato incorrecto"
          // }
        }
      };

      let nuevoFamiliar = {
        nombreDeFamiliar: this.formularioDeEdicionFamiliar.Nombre,
        apellidoPaternoDeFamiliar: this.formularioDeEdicionFamiliar
          .ApellidoPaterno,
        apellidoMaternoDeFamiliar: this.formularioDeEdicionFamiliar
          .ApellidoMaterno,
        telefonoDeFamiliar: this.formularioDeEdicionFamiliar.Telefono,
        fechaNacimientoDeFamiliar: this.formularioDeEdicionFamiliar
          .FechaDeNacimiento,
        calleDeFamiliar: this.formularioDeEdicionFamiliar.Calle,
        numeroExteriorDeFamiliar: this.formularioDeEdicionFamiliar
          .NumeroExterior,
        numeroInteriorDeFamiliar: this.formularioDeEdicionFamiliar
          .NumeroInterior,
        coloniaFraccionamientoDeFamiliar: this.formularioDeEdicionFamiliar
          .ColoniaFraccionamiento,
        codigoPostalDeFamiliar: this.formularioDeEdicionFamiliar.CodigoPostal,

        ////////////// TIPO PARENTESCO
        tipoDeParentescoId: this.formularioDeEdicionFamiliar
          .TipoParentescoFamiliarId,
        nombreTipoParentescoFamiliar: this.formularioDeEdicionFamiliar
          .NombreTipoParentescoFamiliar,

        /////////// ENTIDAD FEDERATIVA
        entidadDeDomicioDelFamiliarId: this.formularioDeEdicionFamiliar
          .EntidadFederativaId,
        // entidadDeDomicioDelFamiliarId: -1,

        ///////////// MUNICIPIO
        municipioDeDomicilioDelFamiliarId: this.formularioDeEdicionFamiliar
          .MunicipioId
      };
      let resultado = validate(nuevoFamiliar, constraints);
      return resultado;
    },

    FinalizarPeriodoComoSuperior(PresuntoSuperiorDadoDeBaja) {
      this.presuntoSuperiorDadoDeBaja = PresuntoSuperiorDadoDeBaja;
      $("#capturaFinalizarFechaDelSuperior").modal("show");
    },

    GuardarFechaFinalComoSuperior() {
      $("#capturaFinalizarFechaDelSuperior").modal("hide");

      this.presuntoSuperiorDadoDeBaja.FechaFinal = this.fechaFinalComoSuperior;

      //Hace la llamada al server para guardar la fecha final
      let peticion = { RelacionSuperior: this.presuntoSuperiorDadoDeBaja };

      axios
        .post(
          api.conexion + api.SIAP.funcion.GuardarFechaFinalComoSuperior,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(
              "La relación Superior-Subordinado ha sido terminada",
              null,
              null
            );
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          console.error("error " + e);
        });

      this.fechaFinalComoSuperior = null;
      this.presuntoSuperiorDadoDeBaja = null;
    },

    SolicitarFechaSuperior(Superior) {
      this.presuntoNuevoSuperior = Superior;
      $("#capturaFechaDelSuperior").modal("show");
    },
    GuardarFechaAltaNuevoSuperior() {
      $("#capturaFechaDelSuperior").modal("hide");
      this.M_Persona.Persona.Superiores.push({
        RelacionSuperiorId: null,
        Superior: this.presuntoNuevoSuperior,
        SuperiorId: this.presuntoNuevoSuperior.PersonaId,
        FechaRegistro: this.fechaInicialComoSuperior
      });

      //Limpia los campos y tabla para realizar una nueva búsqueda
      this.fechaInicialComoSuperior = null;
      this.SuperioresEncontrados = [];
      this.nombreSuperiorBusqueda = null;
      this.numeroNominaSuperiorBusqueda = null;
    },
    QuitarSuperior(indiceSuperior) {
      this.M_Persona.Persona.Superiores.pop(indiceSuperior);
    },
    busquedaSuperiores: function() {
      comun.SeEstaCargandoInformacion(true);
      if (
        this.numeroNominaSuperiorBusqueda != "" &&
        isNaN(this.numeroNominaSuperiorBusqueda)
      ) {
        comun.SeEstaCargandoInformacion(false);
        return;
      }
      var peticion = {
        //Carga los valores para enviar la petición de busqueda
        esPrueba: false,
        nombreBusqueda: this.nombreSuperiorBusqueda,
        numeroNominaBusqueda: parseInt(this.numeroNominaSuperiorBusqueda, 10),
        tipoPuestoBusqueda: false,
        interinoBusqueda: false,
        deBaseBusqueda: false,
        baneados: [1]
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.GetPersonas,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(false);
          if (response.data.SiHayError == false) {
            this.SuperioresEncontrados = response.data.InfoPersonas;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.error(e);
        });
    },
    GuardarSuperiores: function() {
      var peticion = {
        //Carga los valores para enviar la petición de busqueda
        esPrueba: false,
        PersonaId: M_Persona.Persona.PersonaId,
        Superiores: M_Persona.Persona.Superiores
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.AsignarSuperiores,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta("Datos de superior guargados.", null, null);
            this.M_Persona.Persona.Superiores = response.data.Superiores;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    ValidaSiExisteUsuario(OrigenDelValorDeLaCURP) {
      let buscarEstaCURP = "";

      switch (OrigenDelValorDeLaCURP) {
        // El origen "cero" es desde el campo de busqueda de CURP
        case 0:
          buscarEstaCURP = M_Persona.Persona.CURP;
          break;
        // El origen "uno" es desde el valor que tiene el prop. Éste caso es cuando viene del componente de búsqueda.
        case 1:
          buscarEstaCURP = this.propCurp;
          break;
        default:
          buscarEstaCURP = M_Persona.Persona.CURP;
          break;
      }

      comun.SeEstaCargandoInformacion(true);
      if (buscarEstaCURP.length == 18) {
        let peticion = { CURP: buscarEstaCURP };
        axios
          .post(
            api.conexion + api.SIAP.funcion.ExistePersona,
            peticion,
            comun.CrearElHeaderDeAutorizacion(
              this.$store.state.Login_AutorizacionOriginal
            )
          )
          .then(response => {
            comun.SeEstaCargandoInformacion(false);
            if (response.data.SiHayError == false) {
              if (response.data.ExistePersona == true) {
                this.existePersona = true;

                // UNA VEZ QUE SE SABE QUE EXISTE LA PERSONA, SE CONSULTA LA INFORMACIÓN DE LA PERSONA DESDE BASE DE DATOS 
                this.CargarDatosDePersona(buscarEstaCURP);
                this.readOnlyCURP = true;
                this.ActivarNavegacionEntreTabs();
              } else {
                comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);

                //Limpia la información de los formularios de todas las pestañas
                this.VaciarDatosDePersona();

                this.DesactivaBtnGuardarDatosPersonales = false;
                this.noEsPermitidoEditar = false;
              }
            } else {
              comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);

              //Limpia la información de los formularios de todas las pestañas
              this.M_Persona.Persona = this.personaVacia;

              this.DesactivaBtnGuardarDatosPersonales = false;
              this.noEsPermitidoEditar = false;
            }
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.error(e);
          });
      } else {
        comun.SeEstaCargandoInformacion(false);
        comun.mensajeDeAlerta(
          "CURP inválida. La longitud de caracteres debe ser igual a 18 dígitos.",
          null,
          null
        );
        this.VaciarDatosDePersona();
      }
    },

    CargarDatosDePersona(personaCURP) {
      comun.SeEstaCargandoInformacion(true);
      let peticion = {
        CURP: personaCURP,
        ConInactivos: "true",
        ConDomicilio: "true",
        ConTipoEstadoCivil: "true",
        ConSexo: "true",
        ConPais: "true",
        ConEntidadFederativa: "true",
        ConMunicipio: "true",
        ConTelefonos: "true",
        ConHistorialAcademico: "true",
        ConHistorialLaboral: "true",
        ConRelacionSuperiores: "true",
        ConFamiliares: "true",
        ConContrato: "true",
        ConFotoDelRostro: "true",
        ConImagenDeFirmaAutografa: "true"
      };
      axios
        .post(
          api.conexion + api.SIAP.funcion.GetPersona,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          if (response.data.SiHayError == false) {
            console.log(response.data);
            //Formatea los campos de fecha
            var FechaNacimientoFormato = moment(
              response.data.Persona.FechaNacimiento
            ).format("YYYY-MM-DD");
            response.data.Persona.FechaNacimiento = FechaNacimientoFormato;

            // Prepara el listado de números telefónicos
            let arregloNumerosTelefonicos = response.data.Persona.Telefonos;
            this.listadoNumerosTelefonicos = null;
            this.listadoNumerosTelefonicos = new Array(
              arregloNumerosTelefonicos.length
            );
            arregloNumerosTelefonicos.forEach((numeroTelefonico, indice) => {
              if (this.M_Persona.Persona.Telefonos[indice] != null) {
                this.M_Persona.Persona.Telefonos[indice] = numeroTelefonico;
              } else {
                this.M_Persona.Persona.Telefonos.push({
                  TelefonoId: null,
                  PersonaId: null,
                  NumeroTelefono: 0,
                  TipoTelefonoId: null,
                  Activo: null,
                  UsuarioIdQuienRegistra_001DBCUENTAS: null,
                  FechaRegistro: null,
                  TipoTelefono: {
                    TipoTelefonoId: -1,
                    Nombre: null,
                    Activo: null
                  }
                });
              }
            });

            //Pasa la información de la respuesta al modelo que usa el componente
            M_Persona.Persona = response.data.Persona;

            //Vacia los telefonos a la lista de telefonos de la persona
            for (let i = 0; i <= 2; i++) {
              if (arregloNumerosTelefonicos.length == 3) {
                break;
              } else {
                if (this.M_Persona.Persona.Telefonos[i] == null)
                  this.M_Persona.Persona.Telefonos.push({
                    TelefonoId: null,
                    PersonaId: null,
                    NumeroTelefono: 0,
                    TipoTelefonoId: null,
                    Activo: null,
                    UsuarioIdQuienRegistra_001DBCUENTAS: null,
                    FechaRegistro: null,
                    TipoTelefono: {
                      TipoTelefonoId: -1,
                      Nombre: null,
                      Activo: null
                    }
                  });
              }
            }

            //Activa las demás pestañas para que se permitan usar.

            this.DesactivaBtnGuardarDatosPersonales = false;
            this.noEsPermitidoEditar = false;
          } else {
            console.log(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error(e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    ActualizarHistoriaAcademica() {
      let datosInvalidos = this.ValidarDatosAcademicos();
      if (datosInvalidos == undefined) {
        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].Institucion = this.formularioDeEdicionAcademico.NombreInstitucion;

        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].FechaInicio = this.formularioDeEdicionAcademico.FechaInicial;

        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].FechaFin = this.formularioDeEdicionAcademico.FechaFinal;

        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].CedulaProfesional = this.formularioDeEdicionAcademico.Cedula;

        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].TipoNivelAcademico.TipoNivelAcademicoId = this.formularioDeEdicionAcademico.TipoNivelAcademicoId;

        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].TipoNivelAcademico.Nombre = this.formularioDeEdicionAcademico.NombreNivelAcademico;

        // this.M_Persona.Persona.HistoriaAcademica[
        //   this.indiceFilaEnEdicion_HistorialAcademico
        // ].TipoTitulo.TipoTituloId = this.formularioDeEdicionAcademico.TipoTituloId;

        // this.M_Persona.Persona.HistoriaAcademica[
        //   this.indiceFilaEnEdicion_HistorialAcademico
        // ].TipoTitulo.Nombre = this.formularioDeEdicionAcademico.NombreTipoTitulo;

        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].TipoDocumento.TipoDocumentoId = this.formularioDeEdicionAcademico.TipoDocumentoId;

        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].TipoDocumento.Nombre = this.formularioDeEdicionAcademico.NombreTipoDocumento;

        this.M_Persona.Persona.HistoriaAcademica[
          this.indiceFilaEnEdicion_HistorialAcademico
        ].Comentario = this.formularioDeEdicionAcademico.Comentario;

        this.LimpiarFormularioHistorialAcademicoEnEdicion();

        this.habilitarBotonDeEdicionHistoriaAcademica = false;
        this.habilitarBotonDeAgregarHistoriaAcademica = true;
        this.habilitarBotonGuardarDatosHistoriaAcademica = true;
        this.desHabilitaFechaFinalEnAcademicos = false;
      } else {
        console.error(datosInvalidos);
        let camposInvalidos = Object.getOwnPropertyNames(datosInvalidos).sort();
        camposInvalidos.forEach(element => {
          console.log(element.toString());
          let selector = $("#" + element.toString())[0];

          $(selector).popover({
            delay: {
              show: 500,
              hide: 1000
            },
            container: "body",
            placement: "auto",
            trigger: "focus",
            content: "Verificar el formato de este campo"
          });
          $(selector).popover("toggle");
        });
      }
    },

    // Vacia la informacion de la historia academica seleccionada al formulario de edicion de historia academica
    EditarHistoriaAcademica(HistoriaAcademica, indice) {
      this.indiceFilaEnEdicion_HistorialAcademico = indice;

      this.formularioDeEdicionAcademico.NombreInstitucion =
        HistoriaAcademica.Institucion;

      this.formularioDeEdicionAcademico.FechaInicial = moment(
        HistoriaAcademica.FechaInicio
      ).format("YYYY-MM-DD");

      // Si no tiene fecha final que no haga nada
      if (
        HistoriaAcademica.FechaFin != null ||
        HistoriaAcademica.FechaFin != undefined
      ) {
        this.formularioDeEdicionAcademico.FechaFinal = moment(
          HistoriaAcademica.FechaFin
        ).format("YYYY-MM-DD");
        //this.desHabilitaFechaFinalEnAcademicos = false;
      } else {
        this.formularioDeEdicionAcademico.FechaFinal = null;
        //this.desHabilitaFechaFinalEnAcademicos = true;
      }

      this.formularioDeEdicionAcademico.Cedula =
        HistoriaAcademica.CedulaProfesional;

      this.valorDefinido_TipoNivelAcademico_Academico =
        HistoriaAcademica.TipoNivelAcademico.TipoNivelAcademicoId;
      this.formularioDeEdicionAcademico.TipoNivelAcademicoId =
        HistoriaAcademica.TipoNivelAcademico.TipoNivelAcademicoId;
      this.formularioDeEdicionAcademico.NombreNivelAcademico =
        HistoriaAcademica.TipoNivelAcademico.Nombre;

      // this.valorDefinido_TipoTitulo_Academico =
      //   HistoriaAcademica.TipoTitulo.TipoTituloId;
      // this.formularioDeEdicionAcademico.TipoTituloId =
      //   HistoriaAcademica.TipoTitulo.TipoTituloId;
      // this.formularioDeEdicionAcademico.NombreTipoTitulo =
      //   HistoriaAcademica.TipoTitulo.Nombre;

      this.valorDefinido_TipoDocumento_Academico =
        HistoriaAcademica.TipoDocumento.TipoDocumentoId;
      this.formularioDeEdicionAcademico.TipoDocumentoId =
        HistoriaAcademica.TipoDocumento.TipoDocumentoId;
      this.formularioDeEdicionAcademico.NombreTipoDocumento =
        HistoriaAcademica.TipoDocumento.Nombre;

      this.formularioDeEdicionAcademico.Comentario =
        HistoriaAcademica.Comentario;

      this.habilitarBotonDeAgregarHistoriaAcademica = false;
      this.habilitarBotonDeEdicionHistoriaAcademica = true;
      this.habilitarBotonGuardarDatosHistoriaAcademica = false;

      // this.formularioDeEdicionAcademico.FechaFinal != null ||
      // this.formularioDeEdicionAcademico.FechaFinal != undefined
      //   ? this.desHabilitaFechaFinalEnAcademicos = false
      //   : this.desHabilitaFechaFinalEnAcademicos = true;
    },

    QuitarHistoriaLaboral(indiceHistorialLaboral) {
      // this.origenDeDatosTablaHistorialLaboral.pop(indice);
      this.M_Persona.Persona.HistorialLaboral.pop(indiceHistorialLaboral);
    },

    // Pasa la información al formulario de edicion superior de la pagina para permitir la edición de información.
    EditarHistoriaLaboral(dataFila_HistoriaLaboral, indice) {
      //Asigna los valores para usarlos más adelante en el proceso de pintado de la tabla inferior
      this.filaEnEdicion_HistorialLaboral = dataFila_HistoriaLaboral;
      this.indiceFilaEnEdicion_HistorialLaboral = indice;

      // Fechas
      this.fechaInicialPeriodoLaboral = this.obtenFechaConFormatoDDMMYYYY(
        dataFila_HistoriaLaboral.FechaInicial,
        this.formatoDeFechaParaInput
      );
      this.fechaFinalPeriodoLaboral = this.obtenFechaConFormatoDDMMYYYY(
        dataFila_HistoriaLaboral.FechaFinal,
        this.formatoDeFechaParaInput
      );

      // 1) Area
      this.valorDefinido_Area_HistorialLaboral =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId;

      this.parametros_AreaHistorialLaboral_Laborales.Id =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId;

      this.parametros_AreaHistorialLaboral_Laborales.Nombre =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre;

      this.datosLocales[0].valor.Id =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.Area.AreaId;
      this.datosLocales[0].valor.Nombre =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre;

      // 2) Departamento
      this.valorDefinido_TipoDepartamento_HistorialLaboral =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
          .TipoDepartamento != null ||
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
          .TipoDepartamento != undefined
          ? dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
              .TipoDepartamento.TipoDepartamentoId
          : 0;


      this.parametros_TipoDepartamentoLaboral_Laborales.Id =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
          .TipoDepartamento != null ||
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
          .TipoDepartamento != undefined
          ? dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
              .TipoDepartamento.TipoDepartamentoId
          : 0;

      this.parametros_TipoDepartamentoLaboral_Laborales.Nombre =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
          .TipoDepartamento != null ||
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
          .TipoDepartamento != undefined
          ? dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
              .TipoDepartamento.Nombre
          : "Sin Departamento";

      if (
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
          .TipoDepartamento != null ||
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea
          .TipoDepartamento != undefined
      ) {
        this.datosLocales[1].valor.Id =
          dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.TipoDepartamentoId;
        this.datosLocales[1].valor.Nombre =
          dataFila_HistoriaLaboral.EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre;
      } else {
        this.datosLocales[1].valor.Id = 0;
        this.datosLocales[1].valor.Nombre = "Sin Departamento";
      }

      // 3) Puesto
      this.valorDefinido_Puesto_HistorialLaboral = parseInt(
        dataFila_HistoriaLaboral.EstructuraOrganica.Puesto.PuestoId
      );

      this.parametros_TipoPuestoLaboral_Laborales.Id =
        dataFila_HistoriaLaboral.EstructuraOrganica.Puesto.PuestoId;
      this.parametros_TipoPuestoLaboral_Laborales.Nombre =
        dataFila_HistoriaLaboral.EstructuraOrganica.Puesto.Nombre;

      this.datosLocales[2].valor.Id =
        dataFila_HistoriaLaboral.EstructuraOrganica.Puesto.PuestoId;
      this.datosLocales[2].valor.Nombre =
        dataFila_HistoriaLaboral.EstructuraOrganica.Puesto.Nombre;

      this.parametros_Puesto_TabLaborales.AreaId = this.datosLocales[0].valor.Id;
      this.parametros_Puesto_TabLaborales.DepartamentoId = this.datosLocales[1].valor.Id;

      // 4) Tipo Plaza
      this.valorDefinido_TipoPlaza_HistorialLaboral =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoPlaza.TipoPlazaId;
      this.parametros_TipoPuestoPlaza_Laborales.Id =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoPlaza.TipoPlazaId;
      this.parametros_TipoPuestoPlaza_Laborales.Nombre =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoPlaza.Nombre;
      this.datosLocales[3].valor.Id =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoPlaza.TipoPlazaId;
      this.datosLocales[3].valor.Nombre =
        dataFila_HistoriaLaboral.EstructuraOrganica.TipoPlaza.Nombre;

      // 5) Tipo Movimiento
      this.valorDefinido_TipoMovimiento_HistorialLaboral =
        dataFila_HistoriaLaboral.TipoMovimiento.TipoMovimientoId;
      this.parametros_TipoMovimiento_Laborales.Id =
        dataFila_HistoriaLaboral.TipoMovimiento.TipoMovimientoId;
      this.parametros_TipoMovimiento_Laborales.Nombre =
        dataFila_HistoriaLaboral.TipoMovimiento.NombreMovimiento;

      // 6) Tipo Turno
      this.valorDefinido_TipoTurno_HistorialLaboral = dataFila_HistoriaLaboral.EstructuraOrganica.TipoTurno.TipoTurnoId;
      this.parametros_TipoTurno_Laborales.Id = dataFila_HistoriaLaboral.EstructuraOrganica.TipoTurno.TipoTurnoId;
      this.parametros_TipoTurno_Laborales.Nombre = dataFila_HistoriaLaboral.EstructuraOrganica.TipoTurno.Nombre;
      this.datosLocales[4].valor.Id = dataFila_HistoriaLaboral.EstructuraOrganica.TipoTurno.TipoTurnoId;
      this.datosLocales[4].valor.Nombre = dataFila_HistoriaLaboral.EstructuraOrganica.TipoTurno.Nombre;

      // 7) TipoContrato
      this.valorDefinido_TipoContrato_HistorialLaboral =
        dataFila_HistoriaLaboral.TipoContrato.TipoContratoId;
      this.parametros_TipoContrato_Laborales.Id =
        dataFila_HistoriaLaboral.TipoContrato.TipoContratoId;
      this.parametros_TipoContrato_Laborales.Nombre =
        dataFila_HistoriaLaboral.TipoContrato.Nombre;

      // 8) Causó baja
      this.causoBaja = dataFila_HistoriaLaboral.CausoBaja;

      //Activa y desactiva los botones para editar o agregar
      this.habilitarBotonEdicionLaboral = true;
      this.habilitarBotonAgregarHistorialLaboral = false;
    },

    ActualizarHistoriaLaboral() {
      //Causó baja
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].CausoBaja = this.causoBaja;
      
      //Fecha inicial 
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].FechaInicial = this.fechaInicialPeriodoLaboral;

      //Fecha final
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].FechaFinal = this.fechaFinalPeriodoLaboral;

      // AREA
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].EstructuraOrganica.TipoDepartamentoArea.Area.AreaId = this.datosLocales[0].valor.Id;
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].EstructuraOrganica.TipoDepartamentoArea.Area.Nombre = this.datosLocales[0].valor.Nombre;

      // Departamento
      if (
        this.M_Persona.Persona.HistorialLaboral[
          this.indiceFilaEnEdicion_HistorialLaboral
        ].EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento == null ||
        this.M_Persona.Persona.HistorialLaboral[
          this.indiceFilaEnEdicion_HistorialLaboral
        ].EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento == undefined
      ) {
        this.M_Persona.Persona.HistorialLaboral[
          this.indiceFilaEnEdicion_HistorialLaboral
        ].EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento = {
          TipoDepartamentoId: 0,
          Nombre: "Sin Departamento"
        };
      } else {
        this.M_Persona.Persona.HistorialLaboral[
          this.indiceFilaEnEdicion_HistorialLaboral
        ].EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.TipoDepartamentoId = this.datosLocales[1].valor.Id;
        this.M_Persona.Persona.HistorialLaboral[
          this.indiceFilaEnEdicion_HistorialLaboral
        ].EstructuraOrganica.TipoDepartamentoArea.TipoDepartamento.Nombre = this.datosLocales[1].valor.Nombre;
      }

      // Puesto
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].EstructuraOrganica.Puesto.PuestoId = this.parametros_TipoPuestoLaboral_Laborales.Id;
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].EstructuraOrganica.Puesto.Nombre = this.parametros_TipoPuestoLaboral_Laborales.Nombre;

      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].EstructuraOrganica.Puesto.PuestoId = this.datosLocales[2].valor.Id;
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].EstructuraOrganica.Puesto.Nombre = this.datosLocales[2].valor.Nombre;

      // Tipo Plaza
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].EstructuraOrganica.TipoPlaza.TipoPlazaId = this.datosLocales[3].valor.Id;
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].EstructuraOrganica.TipoPlaza.Nombre = this.datosLocales[3].valor.Nombre;

      // Tipo Movimiento
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].TipoMovimiento.TipoMovimientoId = this.parametros_TipoMovimiento_Laborales.Id;
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].TipoMovimiento.NombreMovimiento = this.parametros_TipoMovimiento_Laborales.Nombre;

      // TIPO CONTRATO
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].TipoContrato.TipoContratoId = this.parametros_TipoContrato_Laborales.Id;
      this.M_Persona.Persona.HistorialLaboral[
        this.indiceFilaEnEdicion_HistorialLaboral
      ].TipoContrato.Nombre = this.parametros_TipoContrato_Laborales.Nombre;

      //Limpia el formulario
      this.LimpiarFormularioHistorialLaboral();

      //Vuelve el botón de "Agregar" a visible
      this.habilitarBotonEdicionLaboral = false;
      this.habilitarBotonAgregarHistorialLaboral = true;
    },

    /// Pasa los valores del formulario de edición hacia el modelo de Persona que a su vez alimenta a la tabla de Familiares
    ActualizarInformacionDeFamiliar() {
      // Tipo Parentesco
      if (
        this.formularioDeEdicionFamiliar.TipoParentescoFamiliarId !=
          this.parametros_TipoParentesco_Familiares.Id &&
        this.parametros_TipoParentesco_Familiares.Id > 0
      ) {
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].TipoParentesco.TipoParentescoId = this.parametros_TipoParentesco_Familiares.Id;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].TipoParentesco.Nombre = this.parametros_TipoParentesco_Familiares.Nombre;
      } else {
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].TipoParentesco.TipoParentescoId = this.formularioDeEdicionFamiliar.TipoParentescoFamiliarId;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].TipoParentesco.Nombre = this.formularioDeEdicionFamiliar.NombreTipoParentescoFamiliar;
      }

      // Entidad Federativa
      if (
        this.formularioDeEdicionFamiliar.EntidadFederativaId !=
          this.parametros_EntidadFederativaDeDomicilio_Familiares.Id &&
        this.parametros_EntidadFederativaDeDomicilio_Familiares.Id > 0
      ) {
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.EntidadFederativa.EntidadFederativaId = this.parametros_EntidadFederativaDeDomicilio_Familiares.Id;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.EntidadFederativa.Nombre = this.parametros_EntidadFederativaDeDomicilio_Familiares.Nombre;
      } else {
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.EntidadFederativa.EntidadFederativaId = this.formularioDeEdicionFamiliar.EntidadFederativaId;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.EntidadFederativa.Nombre = this.formularioDeEdicionFamiliar.EntidadFederativaNombre;
      }

      // Municipio
      if (
        this.formularioDeEdicionFamiliar.MunicipioId !=
          this.parametros_MunicipioDeDomicilio_Familiares.Id &&
        this.parametros_MunicipioDeDomicilio_Familiares.Id > 0
      ) {
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.Municipio.MunicipioId = this.parametros_MunicipioDeDomicilio_Familiares.Id;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.Municipio.Nombre = this.parametros_MunicipioDeDomicilio_Familiares.Nombre;
      } else {
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.Municipio.MunicipioId = this.formularioDeEdicionFamiliar.MunicipioId;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.Municipio.Nombre = this.formularioDeEdicionFamiliar.MunicipioNombre;
      }

      let datosInvalidos = this.ValidaDatosFamiliares();
      if (
        datosInvalidos == undefined &&
        this.UnApellidoObligatorio(
          this.formularioDeEdicionFamiliar.ApellidoPaterno,
          this.formularioDeEdicionFamiliar.ApellidoMaterno,
          "El familiar"
        )
      ) {
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Nombre = this.formularioDeEdicionFamiliar.Nombre;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].ApellidoPaterno = this.formularioDeEdicionFamiliar.ApellidoPaterno;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].ApellidoMaterno = this.formularioDeEdicionFamiliar.ApellidoMaterno;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Telefono = this.formularioDeEdicionFamiliar.Telefono;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].DependienteEconomico = this.formularioDeEdicionFamiliar.DependienteEconomico;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].FinadoFamiliar = this.formularioDeEdicionFamiliar.FinadoFamiliar;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].FechaNacimiento = this.formularioDeEdicionFamiliar.FechaDeNacimiento;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.Calle = this.formularioDeEdicionFamiliar.Calle;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.NumeroExterno = this.formularioDeEdicionFamiliar.NumeroExterior;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.NumeroInterno = this.formularioDeEdicionFamiliar.NumeroInterior;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.FraccColonia = this.formularioDeEdicionFamiliar.ColoniaFraccionamiento;
        this.M_Persona.Persona.Familiares[
          this.indiceDelFamiliarEnEdicion
        ].Domicilio.CodigoPostal = this.formularioDeEdicionFamiliar.CodigoPostal;

        this.LimpiarFormularioFamiliarEnEdicion();

        // Activa el botón de agregar nuevo familiar
        this.habilitarBotonDeAgregarFamiliar = true;
        this.habilitarBotonDeEdicionDeFamiliar = false;
        this.habilitarBotonGuardarDatosFamiliares = true;
      } else {
        console.error(datosInvalidos);
        let camposInvalidos = Object.getOwnPropertyNames(datosInvalidos).sort();
        camposInvalidos.forEach(element => {
          console.log(element.toString());
          let selector = $("#" + element.toString())[0];

          $(selector).popover({
            delay: {
              show: 500,
              hide: 1000
            },
            container: "body",
            placement: "auto",
            trigger: "focus",
            content: "Verificar el formato de este campo"
          });
          $(selector).popover("toggle");
        });
      }
    },

    LimpiarFormularioHistorialAcademicoEnEdicion() {
      this.formularioDeEdicionAcademico.NombreInstitucion = null;
      this.formularioDeEdicionAcademico.FechaInicial = null;
      this.formularioDeEdicionAcademico.FechaFinal = null;
      this.formularioDeEdicionAcademico.Cedula = null;

      this.valorDefinido_TipoNivelAcademico_Academico = -1;
      this.formularioDeEdicionAcademico.TipoNivelAcademicoId = null;
      this.formularioDeEdicionAcademico.NombreNivelAcademico = null;

      
      this.formularioDeEdicionAcademico.TipoTituloId = null;
      this.formularioDeEdicionAcademico.NombreTipoTitulo = null;

      this.valorDefinido_TipoDocumento_Academico = -1;
      this.formularioDeEdicionAcademico.TipoDocumentoId = null;
      this.formularioDeEdicionAcademico.NombreTipoDocumento = null;

      this.formularioDeEdicionAcademico.Comentario = null;
    },

    LimpiarFormularioFamiliarEnEdicion() {
      // Limpia los valores del formulario
      this.formularioDeEdicionFamiliar.PersonaId = null;
      this.formularioDeEdicionFamiliar.Nombre = null;
      this.formularioDeEdicionFamiliar.ApellidoPaterno = null;
      this.formularioDeEdicionFamiliar.ApellidoMaterno = null;
      this.formularioDeEdicionFamiliar.Telefono = null;
      this.formularioDeEdicionFamiliar.DependienteEconomico = null;
      this.formularioDeEdicionFamiliar.FinadoFamiliar = null;
      this.formularioDeEdicionFamiliar.FechaDeNacimiento = null;
      this.formularioDeEdicionFamiliar.Calle = null;
      this.formularioDeEdicionFamiliar.NumeroExterior = null;
      this.formularioDeEdicionFamiliar.NumeroInterior = null;
      this.formularioDeEdicionFamiliar.ColoniaFraccionamiento = null;
      this.formularioDeEdicionFamiliar.CodigoPostal = null;

      this.valorDefinido_TipoParentesco_Familiares = null;
      this.formularioDeEdicionFamiliar.TipoParentescoFamiliarId = null;
      this.formularioDeEdicionFamiliar.NombreTipoParentescoFamiliar = null;

      this.valorDefinido_EntidadFederativaDeDomicilio_Familiares = null;
      this.formularioDeEdicionFamiliar.EntidadFederativaId = null;
      this.formularioDeEdicionFamiliar.EntidadFederativaNombre = null;

      this.valorDefinido_MunicipioDeDomicilio_Familiares = null;
      this.formularioDeEdicionFamiliar.MunicipioId = null;
      this.formularioDeEdicionFamiliar.MunicipioNombre = null;
    },

    quitarFamiliar(IndiceDelFamiliar) {
      M_Persona.Persona.Familiares.pop(IndiceDelFamiliar);
    },
    editarFamiliar(Familiar, IndiceDelFamiliar) {
      this.indiceDelFamiliarEnEdicion = IndiceDelFamiliar;

      this.formularioDeEdicionFamiliar.Nombre = Familiar.Nombre;
      this.formularioDeEdicionFamiliar.ApellidoPaterno =
        Familiar.ApellidoPaterno;
      this.formularioDeEdicionFamiliar.ApellidoMaterno =
        Familiar.ApellidoMaterno;
      this.formularioDeEdicionFamiliar.Telefono = Familiar.Telefono;

      this.formularioDeEdicionFamiliar.Calle = Familiar.Domicilio.Calle;
      this.formularioDeEdicionFamiliar.NumeroExterior =
        Familiar.Domicilio.NumeroExterno;
      this.formularioDeEdicionFamiliar.NumeroInterior =
        Familiar.Domicilio.NumeroInterno;
      this.formularioDeEdicionFamiliar.ColoniaFraccionamiento =
        Familiar.Domicilio.FraccColonia;
      this.formularioDeEdicionFamiliar.CodigoPostal =
        Familiar.Domicilio.CodigoPostal;

      this.formularioDeEdicionFamiliar.DependienteEconomico = Familiar.DependienteEconomico;      
      this.formularioDeEdicionFamiliar.FinadoFamiliar = Familiar.FinadoFamiliar;
      this.formularioDeEdicionFamiliar.FechaDeNacimiento = moment(Familiar.FechaNacimiento).format("YYYY-MM-DD");

      // Tipo Parentesco
      // Le establece el valor al componente a través del valor definido y de formularioDeEdicionFamiliar
      this.valorDefinido_TipoParentesco_Familiares =
        Familiar.TipoParentesco.TipoParentescoId;
      this.formularioDeEdicionFamiliar.TipoParentescoFamiliarId =
        Familiar.TipoParentesco.TipoParentescoId;
      this.formularioDeEdicionFamiliar.NombreTipoParentescoFamiliar =
        Familiar.TipoParentesco.Nombre;

      // Entidad Federativa
      // Le establece el valor al componente a través del valor definido y de formularioDeEdicionFamiliar
      this.valorDefinido_EntidadFederativaDeDomicilio_Familiares =
        Familiar.Domicilio.EntidadFederativa.EntidadFederativaId;
      this.formularioDeEdicionFamiliar.EntidadFederativaId =
        Familiar.Domicilio.EntidadFederativa.EntidadFederativaId;
      this.formularioDeEdicionFamiliar.EntidadFederativaNombre =
        Familiar.Domicilio.EntidadFederativa.Nombre;

      // Municipio
      // Le establece el valor al componente a través del valor definido y de formularioDeEdicionFamiliar
      this.valorDefinido_MunicipioDeDomicilio_Familiares =
        Familiar.Domicilio.Municipio.MunicipioId;
      this.formularioDeEdicionFamiliar.MunicipioId =
        Familiar.Domicilio.Municipio.MunicipioId;
      this.formularioDeEdicionFamiliar.MunicipioNombre =
        Familiar.Domicilio.Municipio.Nombre;

      // Activa boton de actualizar información
      this.habilitarBotonDeAgregarFamiliar = false;
      this.habilitarBotonDeEdicionDeFamiliar = true;
      this.habilitarBotonGuardarDatosFamiliares = false;
    },

    /****
     *****       Métodos para obtener los valores de los componentes que se configuraron para trabajar locales ***
     *****/
    cambioDeTipoEstadoCivil(datos) {
      this.parametros_TipoEstadoCivil.tipoEstadoCivilId = parseInt(
        datos.target.value
      );
      M_Persona.Persona.TipoEstadoCivil.TipoEstadoCivilId = parseInt(
        datos.target.value
      );
    },
    cambioDeTipoSexo(datos) {
      this.parametros_TipoSexo.tipoSexoId = parseInt(datos.target.value);
      this.M_Persona.Persona.TipoSexo.TipoSexoId = parseInt(datos.target.value);
    },
    cambioDePaisPeronales(datos) {
      this.parametros_Pais_Personales.paisId = parseInt(datos.target.value);
      this.M_Persona.Persona.PaisDeNacimientoId = parseInt(datos.target.value);
    },
    cambioDeEntidadFederativaDeNacimiento(datos) {
      this.M_Persona.Persona.EntidadFederativa.EntidadFederativaId = parseInt(
        datos.target.value
      );
      this.parametros_EntidadFederativaDeNacimiento_Personales.entidadFederativaId = parseInt(
        datos.target.value
      );
      this.M_Persona.Persona.Municipio.MunicipioId = 0;
    },
    cambioDeMunicipioDeNacimiento(datos) {
      this.M_Persona.Persona.Municipio.MunicipioId = parseInt(
        datos.target.value
      );
      this.parametros_MunicipioDeNacimiento_Personales.municipioId = parseInt(
        datos.target.value
      );
    },
    cambioDeEntidadFederativaDeDomicilio(datos) {
      this.M_Persona.Persona.Domicilio.EntidadFederativa.EntidadFederativaId = parseInt(
        datos.target.value
      );
      this.M_Persona.Persona.Domicilio.Municipio.MunicipioId = 0;
    },
    cambioDeMunicipioDeDomicilio(datos) {
      this.parametros_MunicipioDeDomicilio_Personales.municipioId = parseInt(
        datos.target.value
      );
      M_Persona.Persona.Domicilio.Municipio.MunicipioId = parseInt(
        datos.target.value
      );
    },
    cambioTipoNivelAcademico_Academico(datos) {
      this.valorDefinido_TipoNivelAcademico_Academico = parseInt(
        datos.target.value
      );

      this.parametros_TipoNivelAcademico_Academico.Id = parseInt(
        datos.target.value
      );
      this.parametros_TipoNivelAcademico_Academico.Nombre =
        datos.target.options[datos.target.selectedIndex].text;

      this.formularioDeEdicionAcademico.TipoNivelAcademicoId = this.parametros_TipoNivelAcademico_Academico.Id;
      this.formularioDeEdicionAcademico.NombreNivelAcademico = this.parametros_TipoNivelAcademico_Academico.Nombre;
    },

    cambioTipoTitulo_Academico(datos) {
      //this.valorDefinido_TipoTitulo_Academico = parseInt(datos.target.value);

      // this.parametros_TipoTitulo_Academico.Id = parseInt(datos.target.value);
      // this.parametros_TipoTitulo_Academico.Nombre =
      //   datos.target.options[datos.target.selectedIndex].text;

      // this.formularioDeEdicionAcademico.TipoTituloId = this.parametros_TipoTitulo_Academico.Id;
      // this.formularioDeEdicionAcademico.NombreTipoTitulo = this.parametros_TipoTitulo_Academico.Nombre;

      // Si el tipo título es es "Trunca" deshabilita la captura de la fecha final.
      // if (parseInt(datos.target.value) == enumeraciones.TipoTitulo.Trunca) {
      //   this.desHabilitaFechaFinalEnAcademicos = true;
      //   this.formularioDeEdicionAcademico.FechaFinal = null;
      // } else {
      //   this.desHabilitaFechaFinalEnAcademicos = false;
      // }
    },

    cambioTipoDocumento_Academico(datos) {
      this.valorDefinido_TipoDocumento_Academico = parseInt(datos.target.value);

      this.parametros_TipoDocumento_Academico.Id = parseInt(datos.target.value);
      this.parametros_TipoDocumento_Academico.Nombre =
        datos.target.options[datos.target.selectedIndex].text;

      this.formularioDeEdicionAcademico.TipoDocumentoId = this.parametros_TipoDocumento_Academico.Id;
      this.formularioDeEdicionAcademico.NombreTipoDocumento = this.parametros_TipoDocumento_Academico.Nombre;

      // Si elige la opción "Cédula" o "Título y cédula" habilita el campo "Cedula" para capturar dicho valor.
      if (
        this.formularioDeEdicionAcademico.TipoDocumentoId == 4 ||
        this.formularioDeEdicionAcademico.TipoDocumentoId == 5
      ) {
        this.deshabilitaCedulaProfesional = false;
        this.formularioDeEdicionAcademico.Cedula = "";
      } else {
        this.deshabilitaCedulaProfesional = true;
        this.formularioDeEdicionAcademico.Cedula = "";
      }
    },
    cambioAreaHistorialLaboral(datos) {
      this.datosLocales[0].valor.Id = parseInt(datos.target.value);
      this.datosLocales[0].valor.Nombre =
        datos.target.options[datos.target.selectedIndex].text;

      // Reinicia la selección(valor) del componente de Departamento
      this.datosLocales[1].valor.Id = -1;
      this.datosLocales[1].valor.Nombre = "";

      // Reinicia la selección(valor) del componente de Puesto
      this.datosLocales[2].valor.Id = -1;
      this.datosLocales[2].valor.Nombre = "";
    },
    cambioTipoDepartamentoLaboral(datos) {
      this.datosLocales[1].valor.Id = parseInt(datos.target.value);
      this.datosLocales[1].valor.Nombre =
        datos.target.options[datos.target.selectedIndex].text;

      this.parametros_Puesto_TabLaborales.AreaId = this.datosLocales[0].valor.Id;
      this.parametros_Puesto_TabLaborales.DepartamentoId = this.datosLocales[1].valor.Id;

      this.datosLocales[2].valor.Id = -1;
    },
    cambioTipoPuestoLaboral(datos) {
      // this.valorDefinido_Puesto_HistorialLaboral = parseInt(datos.target.value);
      this.localLaboralesPuesto.Id = datos.target.value;
      this.localLaboralesPuesto.Nombre =
        datos.target[datos.target.selectedIndex].label;
      this.datosLocales[2].valor.Id = parseInt(datos.target.value);
      this.datosLocales[2].valor.Nombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    cambioTipoPlazaLaboral(datos) {
      
      this.datosLocales[3].valor.Id = parseInt(datos.valor);
      this.datosLocales[3].valor.Nombre = datos.etiqueta;
    },
    cambioTipoMovimientoLaboral(datos) {
      this.parametros_TipoMovimiento_Laborales.Id = parseInt(
        datos.target.value
      );
      this.parametros_TipoMovimiento_Laborales.Nombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    cambioTipoTurnoLaboral(datos) {
      
      this.datosLocales[4].valor.Id = parseInt(datos.valor);
      this.datosLocales[4].valor.Nombre = datos.etiqueta;
    },
    cambioTipoContratoLaboral(datos) {
      this.parametros_TipoContrato_Laborales.Id = parseInt(datos.target.value);
      this.parametros_TipoContrato_Laborales.Nombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    cambioTipoParentescoFamiliar(datos) {
      this.parametros_TipoParentesco_Familiares.Id = parseInt(
        datos.target.value
      );
      this.parametros_TipoParentesco_Familiares.Nombre =
        datos.target.options[datos.target.selectedIndex].text;

      this.formularioDeEdicionFamiliar.TipoParentescoFamiliarId = parseInt(
        datos.target.value
      );
      this.formularioDeEdicionFamiliar.NombreTipoParentescoFamiliar =
        datos.target.options[datos.target.selectedIndex].text;
    },
    cambioDeEntidadFederativaFamiliares(datos) {
      this.parametros_EntidadFederativaDeDomicilio_Familiares.Id = parseInt(
        datos.target.value
      );
      this.parametros_EntidadFederativaDeDomicilio_Familiares.Nombre =
        datos.target.options[datos.target.selectedIndex].text;

      this.formularioDeEdicionFamiliar.EntidadFederativaId = parseInt(
        datos.target.value
      );
      this.formularioDeEdicionFamiliar.EntidadFederativaNombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    cambioDeMunicipioFamiliar(datos) {
      this.parametros_MunicipioDeDomicilio_Familiares.Id = parseInt(
        datos.target.value
      );
      this.parametros_MunicipioDeDomicilio_Familiares.Nombre =
        datos.target.options[datos.target.selectedIndex].text;

      this.formularioDeEdicionFamiliar.MunicipioId = parseInt(
        datos.target.value
      );
      this.formularioDeEdicionFamiliar.MunicipioNombre =
        datos.target.options[datos.target.selectedIndex].text;
    },
    LimpiarFormularioHistorialLaboral() {

      this.causoBaja = false;

      this.fechaInicialPeriodoLaboral = null;
      this.fechaFinalPeriodoLaboral = null;

      this.valorDefinido_Area_HistorialLaboral = null;
      this.datosLocales[0].valor.Id = null;

      this.valorDefinido_TipoDepartamento_HistorialLaboral = null;
      this.datosLocales[1].valor.Id = null;

      this.valorDefinido_Puesto_HistorialLaboral = null;
      this.datosLocales[2].valor.Id = null;

      this.valorDefinido_TipoPlaza_HistorialLaboral = null;
      this.datosLocales[3].valor.Id = null;

      // this.valorDefinido_TipoMovimiento_HistorialLaboral = -1;
      this.parametros_TipoMovimiento_Laborales.Id = -1;

      this.valorDefinido_TipoTurno_HistorialLaboral = null;
      this.datosLocales[4].valor.Id = null;

      // this.valorDefinido_TipoContrato_HistorialLaboral = -1;
      this.parametros_TipoContrato_Laborales.Id = -1;
    },
    AbrilModalActivarPersona() {
      $("#activarPersonaModal").modal("show");
    },
    ActivarPersona() {
      $("#activarPersonaModal").modal("hide");
      comun.SeEstaCargandoInformacion(true);

      let peticion = {
        idPersona: this.M_Persona.Persona.PersonaId,
        bandera: true
      };

      axios
        .post(
          api.conexion + api.SIAP.funcion.SetActivoPersona,
          peticion,
          comun.CrearElHeaderDeAutorizacion(
            this.$store.state.Login_AutorizacionOriginal
          )
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(false);
          if (response.data.SiHayError == false) {
            comun.mensajeDeAlerta(response.data.Satisfactorio, null, null);
            this.CargarDatosDePersona(this.M_Persona.Persona.CURP);
          } else {
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
            //Limpia la información de los formularios de todas las pestañas
            this.M_Persona.Persona = this.personaVacia;

            this.DesactivaBtnGuardarDatosPersonales = false;
            this.noEsPermitidoEditar = false;
          }
        })
        .catch(e => {
          comun.SeEstaCargandoInformacion(false);
          console.error(e);
        });
    },
    //Utilidades
    borrarFila: function(event) {
      var boton = event.target;
      var row = boton.parentElement.parentElement;
      if (row.tagName == "TR") {
        row.remove();
      }
    },
    // SubirImagen(event) {
    //   comun.SeEstaCargandoInformacion(true);

    //   // Se carga la imagen al formulario.
    //   var datosDelFormulario = new FormData();
    //   datosDelFormulario.set("PersonaId", M_Persona.Persona.PersonaId);
    //   datosDelFormulario.append("image", event.target.files[0]);

    //   // Elimina la foto para evitar usandola
    //   M_Persona.Persona.RutaImagenRostroByte = null;

    //   axios
    //     .post(
    //       api.conexion + api.SIAP.funcion.GuardarImagen,
    //       datosDelFormulario,
    //       comun.CrearElHeaderDeAutorizacion(
    //         this.$store.state.Login_AutorizacionOriginal,
    //         true
    //       )
    //     )
    //     .then(respuesta => {
    //       console.log(respuesta);
    //       if (respuesta.data.SiHayError) {
    //         comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
    //       } else {
    //         comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
    //         M_Persona.Persona.RutaImagenRostroByte =
    //           respuesta.data.ImagenDataEnBytes;
    //       }
    //       comun.SeEstaCargandoInformacion(false);
    //     })
    //     .catch(excepcion => {
    //       console.log(excepcion);
    //       comun.mensajeDeAlerta(
    //         comun.mensajeDeError(enumeraciones.error.E500),
    //         null,
    //         null
    //       );
    //       comun.SeEstaCargandoInformacion(false);
    //     });
    // }
  }
};
</script>

<style scoped>
.fa-download {
  color: #e5e5e5;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #c7c7c7;
  color: black;
}
read-only {
  background-color: #c7c7c7;
  color: black;
}
hr {
  margin-top: 1em;
}
input:invalid {
  border: 2px solid #e5e5e5;
}
.tab-content {
  padding-top: 15px;
}
.area-inactiva {
  opacity: 0.25;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SIAP/AdministracionPersonal/AltaDeUsuario.vue